(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2390],{

/***/ 98474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AddressSelection; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27812);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(63750);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(89583);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(5434);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(65885);
/* harmony import */ var _api_wave_users__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71231);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88362);
/* harmony import */ var _store_timeslots__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81786);
/* harmony import */ var _store_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73471);
/* harmony import */ var _utils_addressUtilities__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21471);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99700);
/* harmony import */ var _AddressViewModal_AddressViewModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8221);
/* harmony import */ var _Buttons_Buttons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3805);
/* harmony import */ var _AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(33787);
/* harmony import */ var _AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















function AddressSelection(_ref) {
  var _user$address;

  var setIsOpen = _ref.setIsOpen;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      openAddressModal = _useState[0],
      setOpenAddressModal = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(undefined),
      user = _useState2[0],
      setUser = _useState2[1];

  var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z();
  var token = cookies.get('token');
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    var user$ = _store_user__WEBPACK_IMPORTED_MODULE_7__/* ["default"].subscribe */ .Z.subscribe(function (_user) {
      if (!_user) return;

      var myUser = _objectSpread(_objectSpread({}, _user), {}, {
        address: [_user.mainAddress].concat((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(sortAddresses(_user)))
      });

      setUser(myUser);
    });
    return function () {
      user$.unsubscribe();
    };
  }, []);

  function sortAddresses(_user) {
    return _user.address.filter(function (address) {
      var _user$mainAddress;

      return (_user === null || _user === void 0 ? void 0 : (_user$mainAddress = _user.mainAddress) === null || _user$mainAddress === void 0 ? void 0 : _user$mainAddress._id) !== address._id;
    });
  }

  function addAddress(_x) {
    return _addAddress.apply(this, arguments);
  }

  function _addAddress() {
    _addAddress = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(newAddress) {
      var createdAddress, response;
      return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_9__/* .addToAnalytics */ .z2)('addAddres', undefined, [['option', 'submit']]);
              createdAddress = {
                address: [_objectSpread({}, newAddress)]
              };
              _context.next = 4;
              return (0,_api_wave_users__WEBPACK_IMPORTED_MODULE_4__/* .createAddressUser */ .hE)(token, createdAddress);

            case 4:
              response = _context.sent;

              if (!(typeof response === 'string')) {
                _context.next = 8;
                break;
              }

              setOpenAddressModal(false);
              return _context.abrupt("return");

            case 8:
              _store_user__WEBPACK_IMPORTED_MODULE_7__/* ["default"].addAddress */ .Z.addAddress(response === null || response === void 0 ? void 0 : response.address);
              setOpenAddressModal(false);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _addAddress.apply(this, arguments);
  }

  function onClickGetAddress(index) {
    _store_timeslots__WEBPACK_IMPORTED_MODULE_6__/* .TakeAwayTimeslotsStore.update */ .dX.update([]);
    _store_timeslots__WEBPACK_IMPORTED_MODULE_6__/* .ExpressTimeslotsStore.update */ .Ku.update([]);
    _store_timeslots__WEBPACK_IMPORTED_MODULE_6__/* .TakeAwayTimeslotsFetched.update */ .$Q.update(false);
    _store_timeslots__WEBPACK_IMPORTED_MODULE_6__/* .ExpressTimeslotsFetched.update */ .sz.update(false);
    var prevMainAddress = _store_user__WEBPACK_IMPORTED_MODULE_7__/* ["default"].getUserMainAddress */ .Z.getUserMainAddress();
    _store_cart__WEBPACK_IMPORTED_MODULE_5__/* .ValuesToBeUpdated.updateAddress */ .vV.updateAddress(prevMainAddress);
    _store_user__WEBPACK_IMPORTED_MODULE_7__/* ["default"].updateMainAddress */ .Z.updateMainAddress(user.address[index]);
    setIsOpen(false);
  }

  function getAddressTypeIcon(type, index) {
    switch (type) {
      case 'home':
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_16__/* .FaHome */ .xng, {
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressIcon), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressIconSelected), index === 0)),
          alt: type
        });

      case 'work':
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_18__/* .BsBriefcaseFill */ .FKN, {
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressIcon), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressIconSelected), index === 0)),
          alt: type
        });

      default:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_19__/* .MdLocationPin */ .vcr, {
          className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressIcon), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressIconSelected), index === 0)),
          alt: type
        });
    }
  }

  if (!(user !== null && user !== void 0 && user._id)) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
    className: (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressContainer),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
      className: (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressListContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("ul", {
        className: (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addresList),
        children: user === null || user === void 0 ? void 0 : (_user$address = user.address) === null || _user$address === void 0 ? void 0 : _user$address.map(function (a, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("li", {
            className: (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressItem),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("button", {
              className: (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressInfo),
              type: "button",
              onClick: function onClick() {
                return onClickGetAddress(index);
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
                className: (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressInfoContainer),
                children: [getAddressTypeIcon(a.type, index), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressType), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressTypeSelected), index === 0)),
                    children: "".concat((0,_utils_addressUtilities__WEBPACK_IMPORTED_MODULE_8__/* .getAddressTypeInfo */ .oY)(a.type).label, " - ").concat(a.street, " ").concat(a.streetNo)
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
                    className: (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressDetails),
                    children: "".concat(a.street, "\n                             ").concat(a.streetNo, ",\n                              ").concat(a.city, ",\n                               ").concat(a.postalCode)
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
                    className: (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().addressDetails),
                    children: "\u038C\u03C1\u03BF\u03C6\u03BF\u03C2 ".concat(a.floor, ", ").concat(a.nameAtBell)
                  })]
                })]
              })
            })
          }, a._id);
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
      className: (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().buttonContainer),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_11__/* .SecondaryButton */ .kq, {
        onClick: function onClick() {
          return setOpenAddressModal(true);
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
          className: (_AddressSelection_module_scss__WEBPACK_IMPORTED_MODULE_17___default().buttonText),
          children: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2"
        })
      }), openAddressModal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_AddressViewModal_AddressViewModal__WEBPACK_IMPORTED_MODULE_10__["default"], {
        isOpen: openAddressModal,
        setIsOpen: setOpenAddressModal,
        onSubmitCB: addAddress
      })]
    })]
  });
}

/***/ }),

/***/ 49041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AddressSelectionModal; }
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60155);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _AddressSelection_AddressSelection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98474);
/* harmony import */ var _GenericModal_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49906);
/* harmony import */ var _GenericModal_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_GenericModal_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _AddressSelectionModal_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18780);
/* harmony import */ var _AddressSelectionModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_AddressSelectionModal_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








function AddressSelectionModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)((react_modal__WEBPACK_IMPORTED_MODULE_1___default()), {
    className: (_GenericModal_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
    overlayClassName: (_GenericModal_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default().overlay),
    portalClassName: (_AddressSelectionModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modal),
    isOpen: isOpen,
    onRequestClose: setIsOpen,
    contentLabel: "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2 \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7\u03C2",
    ariaHideApp: false,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_AddressSelectionModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header), (_GenericModal_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default().headerClass)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h3", {
          className: (_AddressSelectionModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalHeader),
          children: "\u0395\u03C0\u03AF\u03BB\u03B5\u03BE\u03B5 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7\u03C2"
        }, 1)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", {
        type: "button",
        className: (_AddressSelectionModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().close),
        onClick: function onClick() {
          return setIsOpen(false);
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_6__/* .IoClose */ .bjh, {
          className: (_GenericModal_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_4___default().closeSymbol)
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_AddressSelectionModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().body), 'fullBody']),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_AddressSelectionModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_AddressSelection_AddressSelection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          setIsOpen: setIsOpen
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: (_AddressSelectionModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().footer)
    })]
  });
}

/***/ }),

/***/ 8221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ AddressViewModal; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99700);
/* harmony import */ var _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13764);
/* harmony import */ var _GenericModal_AddressView_AddressView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82998);
/* harmony import */ var _GenericModal_GenericModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49875);
/* harmony import */ var _AddressViewModal_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19563);
/* harmony import */ var _AddressViewModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_AddressViewModal_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function AddressViewModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      onSubmitCB = _ref.onSubmitCB,
      address = _ref.address;
  var modal = {
    isOpen: isOpen,
    closeModal: function closeModal() {
      (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_1__/* .addToAnalytics */ .z2)('addAddres', undefined, [['option', 'Not Submit']]);
      setIsOpen(false);
    },
    customStyles: {
      overlay: _objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__/* ["default"].overlay */ .Z.overlay),
      content: _objectSpread(_objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__/* ["default"].content */ .Z.content), {}, {
        width: '49rem',
        maxWidth: '100%'
      })
    },
    label: 'Εισαγωγή Διεύθυνσης',
    navigation: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h3", {
      className: (_AddressViewModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalHeader),
      children: address ? 'Επεξεργασία Διεύθυνσης' : 'Εισάγετε την διεύθυνση σας.'
    }, 1)],
    view: 'address',
    body: {
      address: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_GenericModal_AddressView_AddressView__WEBPACK_IMPORTED_MODULE_3__["default"], {
        submitForm: onSubmitCB,
        address: address
      })
    }
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_GenericModal_GenericModal__WEBPACK_IMPORTED_MODULE_4__["default"], {
    modal: modal
  });
}

/***/ }),

/***/ 93939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13764);
/* harmony import */ var _Buttons_Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3805);
/* harmony import */ var _GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61429);
/* harmony import */ var _GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








function ConfirmationModal(_ref) {
  var children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      _ref$mainText = _ref.mainText,
      mainText = _ref$mainText === void 0 ? '' : _ref$mainText,
      modalLabel = _ref.modalLabel,
      onClickContinue = _ref.onClickContinue,
      onClickBack = _ref.onClickBack,
      _ref$backBtnText = _ref.backBtnText,
      backBtnText = _ref$backBtnText === void 0 ? 'Ακυρο' : _ref$backBtnText,
      _ref$continueBtnText = _ref.continueBtnText,
      continueBtnText = _ref$continueBtnText === void 0 ? 'Συνέχεια' : _ref$continueBtnText,
      modalClose = _ref.modalClose,
      _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
      shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? true : _ref$shouldCloseOnOve;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isOpen),
      _isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  var _onClickContinue = onClickContinue || closeModal;

  var _onClickBack = onClickBack || closeModal;

  function closeModal() {
    setIsModalOpen(false);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_1___default()), {
    isOpen: _isModalOpen,
    onRequestClose: modalClose,
    style: _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
    contentLabel: modalLabel,
    ariaHideApp: false,
    className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalContent),
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalContainer),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("main", {
        children: children || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
          className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5___default().text),
          children: mainText
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("footer", {
        className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5___default().footer),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .SecondaryButton */ .kq, {
          onClick: _onClickBack,
          children: backBtnText
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .PrimaryButton */ .KM, {
          onClick: _onClickContinue,
          "data-cy": "modal-accept-btn",
          children: continueBtnText
        })]
      })]
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = (ConfirmationModal);

/***/ }),

/***/ 19148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function CustomHead(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [title, " | ", "SUPERMARKET Κρητικός"]
    }), children]
  });
}

/***/ }),

/***/ 13770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GDPRCheckbox; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _GDPRCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74007);
/* harmony import */ var _GDPRCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_GDPRCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function GDPRCheckbox(_ref) {
  var onClickCheckbox = _ref.onClickCheckbox;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: (_GDPRCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().checkboxGeneralContainer),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_GDPRCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().checkboxContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
        className: (_GDPRCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().checkbox),
        name: "terms",
        type: "checkbox",
        onChange: onClickCheckbox
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
      className: (_GDPRCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().checkboxText),
      children: ['Αποδέχομαι τους ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
        href: "/pages/oroi-xrhshs",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
          className: (_GDPRCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().link),
          target: "_blank",
          children: "\u03CC\u03C1\u03BF\u03C5\u03C2 \u03C7\u03C1\u03AE\u03C3\u03B7\u03C2"
        })
      }), ' της υπηρεσίας ', "\u03BA\u03B1\u03B9 \u03C4\u03B7", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
        href: "/pages/prosopika-dedomena",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
          className: (_GDPRCheckbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().link),
          target: "_blank",
          children: "\u0394\u03AE\u03BB\u03C9\u03C3\u03B7 \u03A0\u03C1\u03BF\u03C3\u03C4\u03B1\u03C3\u03AF\u03B1\u03C2 \u03A0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CE\u03BD \u0394\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD."
        })
      })]
    })]
  });
}

/***/ }),

/***/ 44523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GuestView; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 3 modules
var InputAdornment = __webpack_require__(64722);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js + 3 modules
var ThemeProvider = __webpack_require__(72255);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 8 modules
var TextField = __webpack_require__(26);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./src/api/config/index.js + 2 modules
var config = __webpack_require__(65599);
;// CONCATENATED MODULE: ./src/api/guestCredentials.js



var POST_GUEST_USER_CONSENT_ENDPOINT = '/v2/customers/guest';
function postGuestCredentials(_x) {
  return _postGuestCredentials.apply(this, arguments);
}

function _postGuestCredentials() {
  _postGuestCredentials = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(body) {
    var headers, response, _error$response, _error$response$data, _error$response$data$, userMessage;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = {
              appId: "kritikos-web"
            };
            _context.prev = 1;
            _context.next = 4;
            return config/* wave.post */.t.post(POST_GUEST_USER_CONSENT_ENDPOINT, body, {
              headers: headers
            });

          case 4:
            response = _context.sent;

            if (!(response.status !== 201)) {
              _context.next = 7;
              break;
            }

            throw Error('Request failed');

          case 7:
            return _context.abrupt("return", {});

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            userMessage = ((_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.error) === null || _error$response$data$ === void 0 ? void 0 : _error$response$data$.userMessage) || 'Κάτι πήγε στραβά στην υποβολή της φόρμας. Παρακαλούμε προσπάθησε ξανά.';
            return _context.abrupt("return", {
              error: userMessage
            });

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));
  return _postGuestCredentials.apply(this, arguments);
}
// EXTERNAL MODULE: ./src/store/guestUser.js
var guestUser = __webpack_require__(42604);
// EXTERNAL MODULE: ./src/store/isAddressRegistered.js
var isAddressRegistered = __webpack_require__(19094);
// EXTERNAL MODULE: ./src/store/loader.js
var loader = __webpack_require__(58766);
// EXTERNAL MODULE: ./src/utils/themeProvider.js
var themeProvider = __webpack_require__(65168);
// EXTERNAL MODULE: ./src/components/GDPRCheckbox/GDPRCheckbox.jsx
var GDPRCheckbox = __webpack_require__(13770);
// EXTERNAL MODULE: ./src/components/GuestView/GuestView.module.scss
var GuestView_module = __webpack_require__(48902);
var GuestView_module_default = /*#__PURE__*/__webpack_require__.n(GuestView_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/GuestView/GuestView.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var AddressView = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9774), __webpack_require__.e(5642), __webpack_require__.e(7536), __webpack_require__.e(3988), __webpack_require__.e(2998), __webpack_require__.e(8451)]).then(__webpack_require__.bind(__webpack_require__, 82998));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(82998)];
    }
  }
});
var REQUIRED_FIELD = 'Υποχρεωτικό πεδίο';
function GuestView(_ref) {
  var _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? '' : _ref$buttonText,
      onSubmit = _ref.onSubmit;

  var _useState = (0,react.useState)(''),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = (0,react.useState)(''),
      phone = _useState2[0],
      setPhone = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      phoneError = _useState3[0],
      setPhoneError = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      emailError = _useState4[0],
      setEmailError = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      errorMessage = _useState5[0],
      setErrorMessage = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      onClient = _useState6[0],
      setOnClient = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      hasAcceptTerms = _useState7[0],
      setHasAcceptTerms = _useState7[1];

  var _useState8 = (0,react.useState)({
    city: '',
    contactPhone: '',
    floor: '',
    nameAtBell: '',
    postalCode: '',
    street: '',
    streetNo: '',
    type: 'other'
  }),
      address = _useState8[0],
      setAddress = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      hasErrorRegisterGuest = _useState9[0],
      setHasErrorRegistereGuest = _useState9[1];

  var router = (0,next_router.useRouter)();

  function emailValidation() {
    if (!email) {
      setEmailError(REQUIRED_FIELD);
      return false;
    }

    var _email = email.replace(/\s/g, '');

    var isValid = _email.match( // eslint-disable-next-line max-len
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    if (!isValid) {
      setEmailError('Μη έγκυρο email');
    } else {
      setEmailError('');
    }

    return isValid;
  }

  function phoneValidation() {
    if (!phone) {
      setPhoneError(REQUIRED_FIELD);
      return false;
    }

    var numberIdNoSpace = phone.replace(/\s/g, '');
    var isValid = numberIdNoSpace.match(/^\d{10}$/i);

    if (!isValid) {
      setPhoneError('Μη έγκυρο τηλέφωνο');
    } else {
      setPhoneError('');
    }

    return isValid;
  }

  function toggleTerms() {
    setHasAcceptTerms(!hasAcceptTerms);
  }

  function onClickRedirect() {
    router.push({
      pathname: '/login'
    });
  }

  function onSubmitForm(_x) {
    return _onSubmitForm.apply(this, arguments);
  }

  function _onSubmitForm() {
    _onSubmitForm = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var isValidEmail, isValidPhone, guestUserRequestData, _yield$postGuestCrede, error, guestUserData;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isValidEmail = emailValidation();
              isValidPhone = phoneValidation();

              if (!(isValidEmail && isValidPhone)) {
                _context.next = 21;
                break;
              }

              loader/* default.addEvent */.Z.addEvent('REGISTER_GUEST');
              guestUserRequestData = {
                email: email,
                phone: phone,
                termsAccepted: hasAcceptTerms
              };
              _context.next = 7;
              return postGuestCredentials(guestUserRequestData);

            case 7:
              _yield$postGuestCrede = _context.sent;
              error = _yield$postGuestCrede.error;
              loader/* default.removeEvent */.Z.removeEvent('REGISTER_GUEST');

              if (!error) {
                _context.next = 14;
                break;
              }

              setErrorMessage(error);
              setHasErrorRegistereGuest(true);
              return _context.abrupt("return");

            case 14:
              guestUserData = _objectSpread(_objectSpread({}, data), {}, {
                contactPhone: phone,
                email: email,
                type: 'other'
              });
              guestUser/* default.update */.Z.update(guestUserData);
              isAddressRegistered/* PostalCode.update */.Rr.update(data.postalCode);
              isAddressRegistered/* IsAddressRegistered.update */.Zl.update(true);

              if (!onSubmit) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return", onSubmit());

            case 20:
              router.push('/', '/');

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _onSubmitForm.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    var guestUser$ = guestUser/* default.subscribe */.Z.subscribe(function (guestUser) {
      if (guestUser) {
        setAddress({
          city: guestUser.city,
          contactPhone: guestUser.contactPhone,
          floor: guestUser.floor,
          nameAtBell: guestUser.nameAtBell,
          postalCode: guestUser.postalCode,
          street: guestUser.street,
          streetNo: guestUser.streetNo,
          type: 'other'
        });
        setPhone(guestUser.contactPhone);
        setEmail(guestUser.email);
      }
    });
    setOnClient(true);
    return function () {
      guestUser$.unsubscribe();
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
    theme: themeProvider/* theme */.r,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (GuestView_module_default()).detailsContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: (GuestView_module_default()).sectionHeader,
        children: "\u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (GuestView_module_default()).inputContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          sx: {
            height: '5.5rem'
          },
          className: (GuestView_module_default()).box,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
            label: "Email",
            name: "email",
            variant: "outlined",
            onChange: function onChange(e) {
              return setEmail(e.target.value);
            },
            value: email,
            onBlur: emailValidation,
            fullWidth: true,
            required: true,
            error: Boolean(emailError),
            helperText: emailError,
            "data-cy": "email",
            InputProps: {
              endAdornment: emailError && /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "end",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* RiErrorWarningFill */.oji, {
                  className: (GuestView_module_default()).waringIcon
                })
              })
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          sx: {
            height: '5.5rem'
          },
          className: (GuestView_module_default()).box,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
            label: "\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF \u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1\u03C2",
            name: "phone",
            variant: "outlined",
            onChange: function onChange(e) {
              return setPhone(e.target.value);
            },
            onBlur: phoneValidation,
            value: phone,
            fullWidth: true,
            required: true,
            error: Boolean(phoneError),
            helperText: phoneError,
            "data-cy": "userId",
            InputProps: {
              endAdornment: phoneError && /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "end",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* RiErrorWarningFill */.oji, {
                  className: (GuestView_module_default()).waringIcon
                })
              })
            } // eslint-disable-next-line react/jsx-no-duplicate-props
            ,
            inputProps: {
              inputMode: 'numeric',
              pattern: '[0-9]*'
            }
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: (GuestView_module_default()).sectionHeader,
        children: "\u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2"
      }), onClient && /*#__PURE__*/(0,jsx_runtime.jsx)(AddressView, {
        submitForm: onSubmitForm,
        hidePersonalData: true,
        disableSubmit: !hasAcceptTerms,
        address: address,
        buttonText: buttonText,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GDPRCheckbox/* default */.Z, {
          onClickCheckbox: toggleTerms
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (GuestView_module_default()).loginText,
      children: ["\u0388\u03C7\u03B5\u03B9\u03C2 \u03AE\u03B4\u03B7 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC;", /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        onClick: onClickRedirect,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (GuestView_module_default()).loginLink,
          children: " \u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7"
        })
      })]
    }), hasErrorRegisterGuest && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (GuestView_module_default()).errorSmallText,
      children: errorMessage
    })]
  });
}

/***/ }),

/***/ 34247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13764);
/* harmony import */ var _Buttons_Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3805);
/* harmony import */ var _GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61429);
/* harmony import */ var _GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








function InfoModal(_ref) {
  var children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      _ref$mainText = _ref.mainText,
      mainText = _ref$mainText === void 0 ? '' : _ref$mainText,
      modalLabel = _ref.modalLabel,
      onClickContinue = _ref.onClickContinue,
      _ref$continueBtnText = _ref.continueBtnText,
      continueBtnText = _ref$continueBtnText === void 0 ? 'Συνέχεια' : _ref$continueBtnText,
      modalClose = _ref.modalClose;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isOpen),
      _isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  var _onClickContinue = onClickContinue || closeModal;

  function closeModal() {
    setIsModalOpen(false);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_1___default()), {
    isOpen: _isModalOpen,
    onRequestClose: modalClose,
    style: _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
    contentLabel: modalLabel,
    ariaHideApp: false,
    className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalContent),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalContent),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("main", {
          children: children || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
            className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_5___default().text),
            children: mainText
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("footer", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .PrimaryButton */ .KM, {
            onClick: _onClickContinue,
            "data-cy": "modal-accept-btn",
            children: continueBtnText
          })
        })]
      })
    })
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (InfoModal);

/***/ }),

/***/ 26452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13764);
/* harmony import */ var _Buttons_Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3805);
/* harmony import */ var _OrderAlertModal_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17569);
/* harmony import */ var _OrderAlertModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_OrderAlertModal_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








function OrderAlertModal(_ref) {
  var alertText = _ref.alertText,
      isModalOpen = _ref.isModalOpen,
      modalLabel = _ref.modalLabel,
      _ref$continueBtnText = _ref.continueBtnText,
      continueBtnText = _ref$continueBtnText === void 0 ? 'Συνέχεια' : _ref$continueBtnText,
      callback = _ref.callback;
  var customStyles = {
    overlay: _objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__/* ["default"].overlay */ .Z.overlay),
    content: _objectSpread(_objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__/* ["default"].content */ .Z.content), {}, {
      width: '30.5rem',
      maxWidth: '100%'
    })
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_1___default()), {
    isOpen: isModalOpen,
    style: customStyles,
    contentLabel: modalLabel,
    ariaHideApp: false,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_OrderAlertModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalContainer),
      "data-cy": "error-modal",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
        className: (_OrderAlertModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().text),
        children: alertText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .PrimaryButton */ .KM, {
          onClick: callback,
          "data-cy": "alert-ok",
          children: continueBtnText
        })
      })]
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = (OrderAlertModal);

/***/ }),

/***/ 98924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JD": function() { return /* binding */ USER_PROFILE; },
/* harmony export */   "aA": function() { return /* binding */ CATEGORIES; },
/* harmony export */   "jn": function() { return /* binding */ OFFERS; },
/* harmony export */   "ve": function() { return /* binding */ HOMEPAGE; }
/* harmony export */ });
/* unused harmony export ORDER_HISTORY */
var HOMEPAGE = '/';
var USER_PROFILE = '/user';
var ORDER_HISTORY = '/useσr/history';
var OFFERS = '/offers';
var CATEGORIES = '/categories';

/***/ }),

/***/ 15064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ OrderDelivery; }
});

// EXTERNAL MODULE: ./styles/pages/index.module.scss
var index_module = __webpack_require__(28833);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/CustomHead.jsx
var CustomHead = __webpack_require__(19148);
// EXTERNAL MODULE: ./src/components/Footer/Footer.jsx + 5 modules
var Footer = __webpack_require__(31875);
// EXTERNAL MODULE: ./src/components/Header/Header.jsx + 8 modules
var Header = __webpack_require__(3266);
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.jsx
var Navigation = __webpack_require__(86894);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(39666);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/combineLatest.js + 3 modules
var combineLatest = __webpack_require__(60236);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/filter.js
var filter = __webpack_require__(66008);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js
var distinctUntilChanged = __webpack_require__(41931);
// EXTERNAL MODULE: ./src/api/Campaigns.js
var Campaigns = __webpack_require__(33717);
// EXTERNAL MODULE: ./src/api/wave/orders.js
var orders = __webpack_require__(89798);
// EXTERNAL MODULE: ./src/store/campaign.js
var campaign = __webpack_require__(17326);
// EXTERNAL MODULE: ./src/store/cart.js
var cart = __webpack_require__(88362);
// EXTERNAL MODULE: ./src/store/deliveryMode.js
var store_deliveryMode = __webpack_require__(34525);
// EXTERNAL MODULE: ./src/store/guestUser.js
var store_guestUser = __webpack_require__(42604);
// EXTERNAL MODULE: ./src/store/loader.js
var loader = __webpack_require__(58766);
// EXTERNAL MODULE: ./src/store/order.js + 1 modules
var store_order = __webpack_require__(7133);
// EXTERNAL MODULE: ./src/store/productsCollection.js
var productsCollection = __webpack_require__(67713);
// EXTERNAL MODULE: ./src/store/shop.js
var store_shop = __webpack_require__(99777);
// EXTERNAL MODULE: ./src/store/user.js
var store_user = __webpack_require__(73471);
// EXTERNAL MODULE: ./src/utils/analytics.js
var analytics = __webpack_require__(99700);
// EXTERNAL MODULE: ./src/utils/getOffers.js + 1 modules
var getOffers = __webpack_require__(81287);
// EXTERNAL MODULE: ./src/components/AppRatingModal/AppRatingModal.jsx + 4 modules
var AppRatingModal = __webpack_require__(61185);
// EXTERNAL MODULE: ./src/components/Buttons/Buttons.jsx
var Buttons = __webpack_require__(3805);
// EXTERNAL MODULE: ./src/components/ConfirmationModal.jsx
var ConfirmationModal = __webpack_require__(93939);
// EXTERNAL MODULE: ./src/components/GenericModal/TakeAwayStores/TakeAwayModal.jsx + 2 modules
var TakeAwayModal = __webpack_require__(24099);
// EXTERNAL MODULE: ./src/components/InfoModal.jsx
var InfoModal = __webpack_require__(34247);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/skipWhile.js
var skipWhile = __webpack_require__(582);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/map.js
var map = __webpack_require__(55709);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/take.js + 2 modules
var take = __webpack_require__(41226);
// EXTERNAL MODULE: ./src/utils/dayjs.js
var dayjs = __webpack_require__(95286);
// EXTERNAL MODULE: ./src/utils/modalStyle.js
var modalStyle = __webpack_require__(13764);
// EXTERNAL MODULE: ./src/components/MainLogo/MainLogo.jsx
var MainLogo = __webpack_require__(10625);
// EXTERNAL MODULE: ./src/components/OrderAlertModal/OrderAlertSuccess.module.scss
var OrderAlertSuccess_module = __webpack_require__(38851);
var OrderAlertSuccess_module_default = /*#__PURE__*/__webpack_require__.n(OrderAlertSuccess_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/OrderAlertModal/OrderAlertSuccess.jsx












var modalLabel = 'order success message';
function OrderAlertSuccess(_ref) {
  var isModalOpen = _ref.isModalOpen,
      onClickOk = _ref.onClickOk,
      isForGuestUser = _ref.isForGuestUser;

  var _useState = (0,react.useState)(),
      order = _useState[0],
      setOrder = _useState[1];

  (0,react.useEffect)(function () {
    var orderServerResponse$ = store_order/* Order.subject.pipe */.KM.subject.pipe((0,skipWhile/* skipWhile */.n)(function (v) {
      return !(v !== null && v !== void 0 && v.serverResponse);
    }), (0,map/* map */.U)(function (v) {
      return v === null || v === void 0 ? void 0 : v.serverResponse;
    }), (0,take/* take */.q)(1)).subscribe(setOrder);
    store_order/* Order.reset */.KM.reset();
    return function () {
      orderServerResponse$.unsubscribe();
    };
  }, []);
  if (!order) return null;
  var finalPriceString = "".concat(order.totalPrice.toString().substring(0, order.totalPrice.toString().length - 2), ".").concat(order.totalPrice.toString().substr(-2), " \u20AC");
  return /*#__PURE__*/(0,jsx_runtime.jsx)((lib_default()), {
    isOpen: isModalOpen,
    style: modalStyle/* default */.Z,
    contentLabel: modalLabel,
    ariaHideApp: false,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: (OrderAlertSuccess_module_default()).modalContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (OrderAlertSuccess_module_default()).logo,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(MainLogo/* default */.Z, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (OrderAlertSuccess_module_default()).textContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkCircle */.cfq, {
          className: (OrderAlertSuccess_module_default()).checkMark
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (OrderAlertSuccess_module_default()).text,
            children: "\u0397 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 \u03C3\u03BF\u03C5 \u03AE\u03C4\u03B1\u03BD \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AE\u03C2!"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (OrderAlertSuccess_module_default()).detailsText,
            children: "\u0397 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 \u03C3\u03BF\u03C5 \u03BA\u03B1\u03C4\u03B1\u03C7\u03C9\u03C1\u03AE\u03B8\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (OrderAlertSuccess_module_default()).detailsText,
            children: "\u0388\u03C7\u03B5\u03B9 \u03B1\u03C0\u03BF\u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03B1\u03BD\u03C4\u03AF\u03C4\u03C5\u03C0\u03BF \u03C4\u03BF\u03C5 \u03B1\u03C0\u03BF\u03B4\u03B5\u03B9\u03BA\u03C4\u03B9\u03BA\u03BF\u03CD \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2 \u03BA\u03B1\u03B9 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03C3\u03C4\u03BF email \u03C3\u03BF\u03C5."
          })]
        })]
      }), !isForGuestUser && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (OrderAlertSuccess_module_default()).orderInfoContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OrderAlertSuccess_module_default()).orderText,
          children: "\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OrderAlertSuccess_module_default()).orderInfo,
          children: order.user.fullName
        })]
      }), order.orderNumber && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (OrderAlertSuccess_module_default()).orderInfoContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OrderAlertSuccess_module_default()).orderText,
          children: "\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OrderAlertSuccess_module_default()).orderInfo,
          children: order.orderNumber
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (OrderAlertSuccess_module_default()).orderInfoContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OrderAlertSuccess_module_default()).orderText,
          children: "\u03A0\u03BF\u03C3\u03CC \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OrderAlertSuccess_module_default()).orderInfo,
          children: finalPriceString
        })]
      }), order.paymentAuthCode && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (OrderAlertSuccess_module_default()).orderInfoContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OrderAlertSuccess_module_default()).orderText,
          children: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OrderAlertSuccess_module_default()).orderInfo,
          children: order.paymentAuthCode
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (OrderAlertSuccess_module_default()).orderInfoContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OrderAlertSuccess_module_default()).orderText,
          children: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03CE\u03C1\u03B1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OrderAlertSuccess_module_default()).orderInfo,
          children: (0,dayjs/* formatDate */.p6)(order.createdAt, 'DD/MM/YYYY HH:mm')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (OrderAlertSuccess_module_default()).btnContainer,
        "data-cy": "success-order-modal-btn",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* PrimaryButton */.KM, {
          "data-cy": "order-success-ok",
          onClick: onClickOk,
          children: "\u0395\u03BD\u03C4\u03AC\u03BE\u03B5\u03B9"
        })
      })]
    })
  });
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(98924);
// EXTERNAL MODULE: ./src/components/GenericModal/GenericModal.module.scss
var GenericModal_module = __webpack_require__(49906);
var GenericModal_module_default = /*#__PURE__*/__webpack_require__.n(GenericModal_module);
// EXTERNAL MODULE: ./src/components/ProductChangesModal/ProductChangesModal.module.scss
var ProductChangesModal_module = __webpack_require__(1438);
var ProductChangesModal_module_default = /*#__PURE__*/__webpack_require__.n(ProductChangesModal_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/utils/products.js
var products = __webpack_require__(1003);
;// CONCATENATED MODULE: ./src/components/ProductChangesModal/ProductTileChanged.jsx







function ProductTileChanged(_ref) {
  var product = _ref.product,
      unavailable = _ref.unavailable;
  var imgSrc = !product.isSpecialOffer ? (0,products/* productImageURL */.k1)(get_default()(product, 'images.primary', ''), 'cartTile') : get_default()(product, 'image.mobileLarge', ''); // Duplicated code - find by exact match

  var price = !product.isSpecialOffer ? "\u20AC ".concat((product.finalPrice * product.stepToUom / 100).toFixed(2), " ") : "\u20AC ".concat((product.price / 100).toFixed(2), " ");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((ProductChangesModal_module_default()).productTile, (0,defineProperty/* default */.Z)({}, (ProductChangesModal_module_default()).unavailable, unavailable)),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ProductChangesModal_module_default()).productTileImgContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (ProductChangesModal_module_default()).productTileImg,
        src: imgSrc,
        alt: product.name
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ProductChangesModal_module_default()).mainInfo,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (ProductChangesModal_module_default()).info,
        children: product.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (ProductChangesModal_module_default()).extraInfo,
        children: product.displayDescription || product.webSticker
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (ProductChangesModal_module_default()).info,
        children: price
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/ProductChangesModal/ProductChangesModal.jsx















function ProductsChangesModal(_ref) {
  var isModalOpen = _ref.isModalOpen,
      setIsModalOpen = _ref.setIsModalOpen,
      _ref$updatedProducts = _ref.updatedProducts,
      updatedProducts = _ref$updatedProducts === void 0 ? [] : _ref$updatedProducts,
      _ref$unavailableProdu = _ref.unavailableProducts,
      unavailableProducts = _ref$unavailableProdu === void 0 ? [] : _ref$unavailableProdu,
      modifyProduct = _ref.modifyProduct;
  var unavailableLabel = 'Μη διαθέσιμα προϊόντα';
  var updatedLabel = 'Προϊόντα με ανανεωμένες τιμές';
  var modalText = 'Οι τιμές και η διαθεσιμότητα κάποιων προϊόντων που έχεις στο καλάθι σου έχει αλλάξει. Το καλάθι σου θα ανανεωθεί αυτόματα.';

  function closeModal() {
    setIsModalOpen(false);
  }

  (0,react.useEffect)(function () {
    var productsInCart = cart/* productsForOrder.getStorageValue */.cW.getStorageValue();

    if (updatedProducts.length) {
      var productsNotUpdatedInCart = productsInCart.filter(function (product) {
        return !updatedProducts.some(function (p) {
          return product._id === p._id;
        });
      });
      cart/* productsForOrder.update */.cW.update([].concat((0,toConsumableArray/* default */.Z)(productsNotUpdatedInCart), (0,toConsumableArray/* default */.Z)(updatedProducts)));
    }

    if (unavailableProducts.length) {
      var availableProductsInCart = productsInCart.filter(function (product) {
        return !unavailableProducts.some(function (p) {
          return product._id === p._id;
        });
      });
      cart/* productsForOrder.update */.cW.update(availableProductsInCart);
    }

    var _modifyProduct = modifyProduct(),
        _modifyProduct2 = (0,slicedToArray/* default */.Z)(_modifyProduct, 2),
        _modifyProduct2$ = _modifyProduct2[0],
        orderProducts = _modifyProduct2$ === void 0 ? [] : _modifyProduct2$,
        _modifyProduct2$2 = _modifyProduct2[1],
        orderOffers = _modifyProduct2$2 === void 0 ? [] : _modifyProduct2$2;

    var products = orderProducts.length ? orderProducts : undefined;
    store_order/* Order.setProducts */.KM.setProducts(products);
    var offers = orderOffers.length ? orderOffers : undefined;
    store_order/* Order.setOffers */.KM.setOffers(offers);
  }, [updatedProducts, unavailableProducts]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((lib_default()), {
    className: (ProductChangesModal_module_default()).content,
    overlayClassName: (GenericModal_module_default()).overlay,
    portalClassName: (GenericModal_module_default()).modal,
    isOpen: isModalOpen,
    onRequestClose: closeModal,
    contentLabel: "A\u03BD\u03B1\u03BD\u03AD\u03C9\u03C3\u03B7 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD \u03BA\u03B1\u03BB\u03B1\u03B8\u03B9\u03BF\u03CD",
    ariaHideApp: false,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ProductChangesModal_module_default()).header,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: (ProductChangesModal_module_default()).headerTitle,
        children: "A\u03BD\u03B1\u03BD\u03AD\u03C9\u03C3\u03B7 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD \u03BA\u03B1\u03BB\u03B1\u03B8\u03B9\u03BF\u03CD"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        type: "button",
        className: (ProductChangesModal_module_default()).closeBtn,
        onClick: closeModal,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(io5_index_esm/* IoClose */.bjh, {
          className: (ProductChangesModal_module_default()).closeModal
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ProductChangesModal_module_default()).body,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (ProductChangesModal_module_default()).message,
        children: modalText
      }), updatedProducts.length !== 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (ProductChangesModal_module_default()).sectionTitle,
          children: updatedLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ProductChangesModal_module_default()).productsContainer,
          children: updatedProducts.map(function (product) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductTileChanged, {
              product: product
            });
          })
        })]
      }), unavailableProducts.length !== 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (ProductChangesModal_module_default()).sectionTitle,
          children: unavailableLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ProductChangesModal_module_default()).productsContainer,
          children: unavailableProducts.map(function (product) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductTileChanged, {
              product: product,
              unavailable: true
            });
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ProductChangesModal_module_default()).footer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: routes/* OFFERS */.jn,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (ProductChangesModal_module_default()).btnSecondary,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* SecondaryButton */.kq, {
            children: "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ProductChangesModal_module_default()).rightButton,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* PrimaryButton */.KM, {
          onClick: closeModal,
          children: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1"
        })
      })]
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(65885);
// EXTERNAL MODULE: ./src/api/wave/users.js
var users = __webpack_require__(71231);
// EXTERNAL MODULE: ./src/utils/addressUtilities.js
var addressUtilities = __webpack_require__(21471);
// EXTERNAL MODULE: ./src/components/AddressSelectionModal/AddressSelectionModal.jsx
var AddressSelectionModal = __webpack_require__(49041);
// EXTERNAL MODULE: ./src/components/AddressViewModal/AddressViewModal.jsx
var AddressViewModal = __webpack_require__(8221);
// EXTERNAL MODULE: ./src/components/GuestView/GuestView.jsx + 1 modules
var GuestView = __webpack_require__(44523);
// EXTERNAL MODULE: ./src/components/GuestDetailsModal/GuestDetailsModal.module.scss
var GuestDetailsModal_module = __webpack_require__(4401);
var GuestDetailsModal_module_default = /*#__PURE__*/__webpack_require__.n(GuestDetailsModal_module);
;// CONCATENATED MODULE: ./src/components/GuestDetailsModal/GuestDetailsModal.jsx







function GuestDetailsModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((lib_default()), {
    className: (GuestDetailsModal_module_default()).content,
    overlayClassName: (GuestDetailsModal_module_default()).overlay,
    portalClassName: (GuestDetailsModal_module_default()).modal,
    isOpen: isOpen,
    onRequestClose: setIsOpen,
    contentLabel: "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD",
    ariaHideApp: false,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()((GuestDetailsModal_module_default()).header, (GuestDetailsModal_module_default()).headerClass),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: (GuestDetailsModal_module_default()).modalHeader,
          children: "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD"
        }, 1)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        type: "button",
        className: (GuestDetailsModal_module_default()).close,
        onClick: function onClick() {
          return setIsOpen(false);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(io5_index_esm/* IoClose */.bjh, {
          className: (GuestDetailsModal_module_default()).closeSymbol
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(GuestDetailsModal_module_default()).body, 'fullBody']),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (GuestDetailsModal_module_default()).container,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GuestView/* default */.Z, {
          onSubmit: setIsOpen
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (GuestDetailsModal_module_default()).footer
    })]
  });
}
// EXTERNAL MODULE: ./src/components/OrderDeliveryForm/AddressPicker.module.scss
var AddressPicker_module = __webpack_require__(25614);
var AddressPicker_module_default = /*#__PURE__*/__webpack_require__.n(AddressPicker_module);
;// CONCATENATED MODULE: ./src/components/OrderDeliveryForm/AddressPicker.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





















function AddressPicker(_ref) {
  var _ref$guestTakeAway = _ref.guestTakeAway,
      guestTakeAway = _ref$guestTakeAway === void 0 ? false : _ref$guestTakeAway;

  var _useState = (0,react.useState)(undefined),
      address = _useState[0],
      setAddress = _useState[1];

  var _useState2 = (0,react.useState)(false),
      openAddressModal = _useState2[0],
      setOpenAddressModal = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      openAddressSelectionModal = _useState3[0],
      setOpenAddressSelectionModal = _useState3[1];

  var _useState4 = (0,react.useState)({}),
      guestUser = _useState4[0],
      setGuestUser = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isGuestModalOpen = _useState5[0],
      setIsGuestModalOpen = _useState5[1];

  var _useState6 = (0,react.useState)({}),
      user = _useState6[0],
      setUser = _useState6[1];

  var cookies = new es6/* default */.Z();
  var token = cookies.get('token');
  (0,react.useEffect)(function () {
    var user$ = (0,combineLatest/* combineLatest */.aj)([store_user/* default._lazyInit */.Z._lazyInit(), store_guestUser/* default._lazyInit */.Z._lazyInit()]).subscribe(function (res) {
      var _user$address;

      var _user = res[0];
      var guest = res[1];
      setUser(_user);
      setGuestUser(guest);
      var userAddress = (_user === null || _user === void 0 ? void 0 : _user.mainAddress) || (_user === null || _user === void 0 ? void 0 : (_user$address = _user.address) === null || _user$address === void 0 ? void 0 : _user$address[0]) || guest;
      setAddress(userAddress);
      store_order/* Order.setSelectedAddress */.KM.setSelectedAddress(userAddress);
    });
    return function () {
      user$.unsubscribe();
    };
  }, []);

  function addAddress(_x) {
    return _addAddress.apply(this, arguments);
  }

  function _addAddress() {
    _addAddress = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(newAddress) {
      var addressToCreate, response, _user;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0,analytics/* addToAnalytics */.z2)('addAddres', undefined, [['option', 'submit']]);
              addressToCreate = {
                address: [_objectSpread({}, newAddress)]
              };
              _context.next = 4;
              return (0,users/* createAddressUser */.hE)(token, addressToCreate);

            case 4:
              response = _context.sent;

              if (!(typeof response === 'string')) {
                _context.next = 8;
                break;
              }

              setOpenAddressModal(false);
              return _context.abrupt("return");

            case 8:
              store_user/* default.addAddress */.Z.addAddress(response === null || response === void 0 ? void 0 : response.address);
              _user = store_user/* default.getValue */.Z.getValue();
              if (!_user.mainAddress) store_user/* default.updateMainAddress */.Z.updateMainAddress(response === null || response === void 0 ? void 0 : response.address);
              setOpenAddressModal(false);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _addAddress.apply(this, arguments);
  }

  function getAddressTypeIcon(type) {
    switch (type) {
      case 'home':
        return /*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaHome */.xng, {
          className: (AddressPicker_module_default()).addressIcon,
          alt: type
        });

      case 'work':
        return /*#__PURE__*/(0,jsx_runtime.jsx)(bs_index_esm/* BsBriefcaseFill */.FKN, {
          className: (AddressPicker_module_default()).addressIcon,
          alt: type
        });

      default:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiMapPin */.i63, {
          className: (AddressPicker_module_default()).addressIcon,
          alt: type
        });
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (AddressPicker_module_default()).section,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (AddressPicker_module_default()).addressTitle,
      children: guestTakeAway ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "\u200B"
      }) : 'ΔΙΕΥΘΥΝΣΗ ΠΑΡΑΔΟΣΗΣ'
    }), address ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: (AddressPicker_module_default()).instructions,
        children: [guestTakeAway && 'Τα επιλεγμένα στοιχεία επικοινωνίας και η διεύθυνση σου.', (user === null || user === void 0 ? void 0 : user._id) && 'Η επιλεγμένη διεύθυνση στην οποία θα παραδώσουμε τις αγορές σου.', (guestUser === null || guestUser === void 0 ? void 0 : guestUser.email) && !guestTakeAway && 'Τα επιλεγμένα στοιχεία επικοινωνίας και η διεύθυνση στην οποία θα παραδώσουμε τις αγορές σου.']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (AddressPicker_module_default()).containerAddress,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (AddressPicker_module_default()).addressInfo,
          children: [getAddressTypeIcon(address === null || address === void 0 ? void 0 : address.type), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (AddressPicker_module_default()).addressDetails,
            children: [!(guestUser !== null && guestUser !== void 0 && guestUser.email) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (AddressPicker_module_default()).addressType,
              children: (0,addressUtilities/* getAddressTypeInfo */.oY)(address.type).label
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "".concat(address.street, " ").concat(address.streetNo, ", ").concat(address.city, ", ").concat(address.postalCode)
            }), address.floor && address.nameAtBell && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "\u03CC\u03C1\u03BF\u03C6\u03BF\u03C2: ".concat(address.floor, ", ").concat(address.nameAtBell)
            }), address.contactPhone && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [address.contactPhone, (guestUser === null || guestUser === void 0 ? void 0 : guestUser.email) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                children: [", ", guestUser.email]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (AddressPicker_module_default()).btnContainer,
          children: guestUser !== null && guestUser !== void 0 && guestUser.email ? /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* SecondaryButton */.kq, {
            onClick: function onClick() {
              return setIsGuestModalOpen(!isGuestModalOpen);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (AddressPicker_module_default()).buttonText,
              children: "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* SecondaryButton */.kq, {
            onClick: function onClick() {
              return setOpenAddressSelectionModal(!openAddressSelectionModal);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (AddressPicker_module_default()).buttonText,
              children: "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2"
            })
          })
        })]
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (AddressPicker_module_default()).instructions,
        children: "\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9\u03C2 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7, \u03C0\u03AC\u03C4\u03B1 \u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03BC\u03B9\u03B1 \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03BF\u03C5."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (AddressPicker_module_default()).btnContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* SecondaryButton */.kq, {
          onClick: function onClick() {
            return setOpenAddressModal(true);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (AddressPicker_module_default()).buttonText,
            children: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2"
          })
        })
      })]
    }), openAddressSelectionModal && /*#__PURE__*/(0,jsx_runtime.jsx)(AddressSelectionModal["default"], {
      isOpen: openAddressSelectionModal,
      setIsOpen: setOpenAddressSelectionModal
    }), isGuestModalOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(GuestDetailsModal, {
      isOpen: isGuestModalOpen,
      setIsOpen: setIsGuestModalOpen
    }), openAddressModal && /*#__PURE__*/(0,jsx_runtime.jsx)(AddressViewModal["default"], {
      isOpen: openAddressModal,
      setIsOpen: setOpenAddressModal,
      onSubmitCB: addAddress
    })]
  });
}
// EXTERNAL MODULE: ./src/components/OrderDeliveryForm/OrderDeliveryForm.module.scss
var OrderDeliveryForm_module = __webpack_require__(73019);
var OrderDeliveryForm_module_default = /*#__PURE__*/__webpack_require__.n(OrderDeliveryForm_module);
// EXTERNAL MODULE: ./node_modules/big.js/big.js
var big = __webpack_require__(93302);
var big_default = /*#__PURE__*/__webpack_require__.n(big);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-switch/index.js
var react_switch = __webpack_require__(59936);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 3 modules
var InputAdornment = __webpack_require__(64722);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js + 3 modules
var ThemeProvider = __webpack_require__(72255);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 8 modules
var TextField = __webpack_require__(26);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/api/wave/coupon.js





var baseURL = "".concat("https://kritikos-cxm-production.herokuapp.com", "/api/offers");
var cookies = new es6/* default */.Z();
var token = cookies.get('token');
function checkCoupon(_x, _x2) {
  return _checkCoupon.apply(this, arguments);
}

function _checkCoupon() {
  _checkCoupon = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(couponCode, authToken) {
    var response, res;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axios_default().get("".concat(baseURL, "/checkCouponIsValid/").concat(couponCode), {
              headers: {
                appId: "kritikos-web",
                authorization: "Bearer ".concat(authToken || token)
              }
            });

          case 3:
            response = _context.sent;
            res = get_default()(response, 'data.payload.coupons');
            return _context.abrupt("return", res);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", Promise.reject(_context.t0.response.data));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _checkCoupon.apply(this, arguments);
}

/* harmony default export */ var coupon = ({
  checkCoupon: checkCoupon
});
// EXTERNAL MODULE: ./src/utils/themeProvider.js
var themeProvider = __webpack_require__(65168);
// EXTERNAL MODULE: ./src/components/OrderDeliveryForm/OrderPreferences.module.scss
var OrderPreferences_module = __webpack_require__(13611);
var OrderPreferences_module_default = /*#__PURE__*/__webpack_require__.n(OrderPreferences_module);
;// CONCATENATED MODULE: ./src/components/OrderFormComponents/OrderCouponForm.jsx



var _excluded = ["ref", "onChange"];


function OrderCouponForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function OrderCouponForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { OrderCouponForm_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { OrderCouponForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















function OrderCouponForm(_ref) {
  var _cn3;

  var control = _ref.control,
      couponNo = _ref.couponNo,
      guestUser = _ref.guestUser;

  var _useState = (0,react.useState)(false),
      couponUse = _useState[0],
      setCouponUse = _useState[1];

  var _useState2 = (0,react.useState)(''),
      couponError = _useState2[0],
      setCouponError = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      couponSuccess = _useState3[0],
      setCouponSuccess = _useState3[1];

  var REQUIRED_FIELD = 'Υποχρεωτικό πεδίο';
  var errorMessages = {
    couponNo: {
      required: REQUIRED_FIELD,
      minLength: 'Μη έγκυρη τιμή'
    }
  };

  function onChangeCouponUse() {
    setCouponUse(!couponUse);

    if (couponUse) {
      store_order/* Order.setCouponCode */.KM.setCouponCode(undefined);
      store_order/* CouponDiscount.update */.P8.update(0);
    }
  }

  function onKeyPressCoupon(e) {
    if (e.key === 'Enter') e.preventDefault();
  }

  function onClickCouponArrow() {
    return _onClickCouponArrow.apply(this, arguments);
  }

  function _onClickCouponArrow() {
    _onClickCouponArrow = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _order, couponText, price, user, token, res, discount, _err$error;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _order = store_order/* Order.getValue */.KM.getValue();

              if (!(_order !== null && _order !== void 0 && _order.couponCode)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              couponText = couponNo.toUpperCase();

              if (!(couponText.length > 4)) {
                _context.next = 41;
                break;
              }

              setCouponError('');
              setCouponSuccess('');
              price = cart/* cartPrice.getValue */.O0.getValue();
              _context.prev = 8;
              user = store_user/* default.getValue */.Z.getValue();
              token = user === null || user === void 0 ? void 0 : user.authToken;
              _context.next = 13;
              return checkCoupon(couponText, token);

            case 13:
              res = _context.sent;

              if (!(res.offerType === 'amount')) {
                _context.next = 23;
                break;
              }

              if (!(res.price > price)) {
                _context.next = 19;
                break;
              }

              setCouponError('Η αξία του κουπονίου δεν μπορεί να είναι μεγαλύτερη από την τιμή του καλαθιού');
              store_order/* CouponDiscount.update */.P8.update(0);
              return _context.abrupt("return");

            case 19:
              setCouponSuccess("To \u03BA\u03BF\u03C5\u03C0\u03CC\u03BD\u03B9 \u03C3\u03BF\u03C5 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03B8\u03B7\u03BA\u03B5! \n \u039A\u03B5\u03C1\u03B4\u03AF\u03B6\u03B5\u03B9\u03C2 \u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7 ".concat((res.price / 100).toFixed(2), "\u20AC!"));
              store_order/* CouponDiscount.update */.P8.update(res.price);
              store_order/* Order.setCouponCode */.KM.setCouponCode(couponText);
              return _context.abrupt("return");

            case 23:
              if (!(res.offerType === 'percentage')) {
                _context.next = 34;
                break;
              }

              discount = price * res.price / 100;

              if (!(discount > price)) {
                _context.next = 29;
                break;
              }

              setCouponError('Η αξία του κουπονίου δεν μπορεί να είναι μεγαλύτερη από την τιμή του καλαθιού');
              store_order/* CouponDiscount.update */.P8.update(0);
              return _context.abrupt("return");

            case 29:
              setCouponSuccess("To \u03BA\u03BF\u03C5\u03C0\u03CC\u03BD\u03B9 \u03C3\u03BF\u03C5 \u03B5\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03B9\u03CE\u03B8\u03B7\u03BA\u03B5! \n \u039A\u03B5\u03C1\u03B4\u03AF\u03B6\u03B5\u03B9\u03C2 \u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7 ".concat((discount / 100).toFixed(2), "\u20AC!"));
              store_order/* CouponDiscount.update */.P8.update(discount);
              store_order/* Order.setCouponCode */.KM.setCouponCode(couponText);
              setCouponError('');
              return _context.abrupt("return");

            case 34:
              _context.next = 41;
              break;

            case 36:
              _context.prev = 36;
              _context.t0 = _context["catch"](8);
              setCouponSuccess('');
              store_order/* CouponDiscount.update */.P8.update(0);
              setCouponError(_context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$error = _context.t0.error) === null || _err$error === void 0 ? void 0 : _err$error.userMessage);

            case 41:
              store_order/* CouponDiscount.update */.P8.update(0);

            case 42:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 36]]);
    }));
    return _onClickCouponArrow.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    setCouponSuccess('');
  }, [couponNo]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (OrderPreferences_module_default()).checkBoxContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      className: (OrderPreferences_module_default()).checkBoxLabel,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: classnames_default()((OrderPreferences_module_default()).labelText, (0,defineProperty/* default */.Z)({}, (OrderPreferences_module_default()).opacity, guestUser === null || guestUser === void 0 ? void 0 : guestUser.email)),
        children: ["\u039A\u03BF\u03C5\u03C0\u03CC\u03BD\u03B9 \u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7\u03C2", ' ', (guestUser === null || guestUser === void 0 ? void 0 : guestUser.email) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          title: "\u039A\u03AC\u03BD\u03B5 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03BA\u03B1\u03B9 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B5 \u03C4\u03BF \u03BA\u03BF\u03C5\u03C0\u03CC\u03BD\u03B9 \u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7\u03C2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ai_index_esm/* AiFillInfoCircle */.kA6, {
            className: (OrderPreferences_module_default()).infoIcon
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_switch["default"], {
        disabled: Boolean(guestUser === null || guestUser === void 0 ? void 0 : guestUser.email),
        checked: couponUse,
        onChange: onChangeCouponUse,
        boxShadow: OrderPreferences_module.boxShadow,
        activeBoxShadow: OrderPreferences_module.boxShadow,
        onColor: OrderPreferences_module.brandColorMuted,
        onHandleColor: OrderPreferences_module.brandColor,
        handleDiameter: 20,
        uncheckedIcon: false,
        checkedIcon: false,
        height: 14,
        width: 32,
        className: "react-switch"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: classnames_default()((OrderPreferences_module_default()).details, (0,defineProperty/* default */.Z)({}, (OrderPreferences_module_default()).opacity, guestUser === null || guestUser === void 0 ? void 0 : guestUser.email)),
      children: "\u0395\u03B9\u03C3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03BA\u03BF\u03C5\u03C0\u03CC\u03BD\u03B9 \u03C3\u03C4\u03BF \u03C0\u03B1\u03C1\u03B1\u03BA\u03AC\u03C4\u03C9 \u03C0\u03B5\u03B4\u03AF\u03BF \u03BA\u03B1\u03B9 \u03C0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03B2\u03B5\u03BB\u03AC\u03BA\u03B9 \u03CE\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03C3\u03C4\u03B5\u03AF \u03B7 \u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((OrderPreferences_module_default()).couponInputContainer, (_cn3 = {}, (0,defineProperty/* default */.Z)(_cn3, (OrderPreferences_module_default()).hideOnUnselected, !couponUse), (0,defineProperty/* default */.Z)(_cn3, (OrderPreferences_module_default()).appearOnSelected, couponUse), _cn3)),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          height: '5.5rem',
          width: '20rem'
        },
        className: (OrderPreferences_module_default()).box,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
          theme: themeProvider/* theme */.r,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
            control: control,
            name: "couponNo",
            defaultValue: "",
            rules: {
              required: couponUse,
              minLength: 5
            },
            render: function render(_ref2) {
              var _ref2$field = _ref2.field,
                  ref = _ref2$field.ref,
                  onChange = _ref2$field.onChange,
                  field = (0,objectWithoutProperties/* default */.Z)(_ref2$field, _excluded),
                  error = _ref2.fieldState.error;

              return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, OrderCouponForm_objectSpread(OrderCouponForm_objectSpread({}, field), {}, {
                label: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03BF\u03C5\u03C0\u03BF\u03BD\u03B9\u03BF\u03CD",
                fullWidth: true,
                variant: "outlined",
                onChange: onChange,
                onKeyPress: onKeyPressCoupon,
                error: error !== undefined || Boolean(couponError),
                helperText: error && errorMessages.couponNo[error.type] || couponError,
                InputProps: {
                  endAdornment: /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                    position: "end",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                      type: "button",
                      onClick: onClickCouponArrow,
                      className: (OrderPreferences_module_default()).resetButton,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(bs_index_esm/* BsFillArrowRightCircleFill */.Igg, {
                        className: (OrderPreferences_module_default()).couponArrow
                      })
                    })
                  })
                }
              }));
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OrderPreferences_module_default()).couponSuccess,
          children: couponSuccess
        })]
      })
    })]
  });
}

/* harmony default export */ var OrderFormComponents_OrderCouponForm = (OrderCouponForm);
;// CONCATENATED MODULE: ./src/components/OrderFormComponents/OrderInvoiceForm.jsx


var OrderInvoiceForm_excluded = ["ref", "onChange"],
    _excluded2 = ["ref", "onChange"],
    _excluded3 = ["ref", "onChange"],
    _excluded4 = ["ref", "onChange"],
    _excluded5 = ["ref", "onChange"],
    _excluded6 = ["ref", "onChange"];

function OrderInvoiceForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function OrderInvoiceForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { OrderInvoiceForm_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { OrderInvoiceForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














function OrderInvoiceForm(_ref) {
  var _cn;

  var control = _ref.control;
  var REQUIRED_FIELD = 'Υποχρεωτικό πεδίο';
  var errorMessages = {
    companyPhone: {
      required: REQUIRED_FIELD,
      pattern: 'Με έγκυρη τιμή'
    },
    AFM: {
      required: REQUIRED_FIELD,
      errorAFMPattern: 'Με έγκυρη τιμή'
    }
  };

  var _useState = (0,react.useState)(false),
      invoiceUse = _useState[0],
      setInvoiceUse = _useState[1];

  function onChangeInvoiceUse() {
    if (!invoiceUse) {
      store_order/* Order.deleteProperty */.KM.deleteProperty(['invoice']);
    }

    setInvoiceUse(!invoiceUse);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (OrderPreferences_module_default()).checkBoxContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      htmlFor: "",
      className: (OrderPreferences_module_default()).checkBoxLabel,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (OrderPreferences_module_default()).labelText,
        children: "\u0388\u03BA\u03B4\u03BF\u03C3\u03B7 \u03C4\u03B9\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03BF\u03C5"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_switch["default"], {
        checked: invoiceUse,
        onChange: onChangeInvoiceUse,
        onColor: OrderPreferences_module.brandColorMuted,
        onHandleColor: OrderPreferences_module.brandColor,
        checkedIcon: false,
        uncheckedIcon: false,
        boxShadow: OrderPreferences_module.boxShadow,
        activeBoxShadow: OrderPreferences_module.boxShadow,
        height: 14,
        width: 32,
        handleDiameter: 20,
        className: "react-switch"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
      theme: themeProvider/* theme */.r,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((_cn = {}, (0,defineProperty/* default */.Z)(_cn, (OrderPreferences_module_default()).hideOnUnselected, !invoiceUse), (0,defineProperty/* default */.Z)(_cn, (OrderPreferences_module_default()).appearOnSelected, invoiceUse), _cn)),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (OrderPreferences_module_default()).invoiceInputContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              height: '5.5rem',
              flex: '0.45 1 0'
            },
            className: (OrderPreferences_module_default()).box,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
              control: control,
              name: "companyName",
              defaultValue: "",
              rules: {
                required: invoiceUse
              },
              render: function render(_ref2) {
                var _ref2$field = _ref2.field,
                    ref = _ref2$field.ref,
                    onChange = _ref2$field.onChange,
                    field = (0,objectWithoutProperties/* default */.Z)(_ref2$field, OrderInvoiceForm_excluded),
                    error = _ref2.fieldState.error;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, OrderInvoiceForm_objectSpread(OrderInvoiceForm_objectSpread({}, field), {}, {
                  label: "\u0395\u03C0\u03C9\u03BD\u03C5\u03BC\u03AF\u03B1",
                  fullWidth: true,
                  variant: "outlined",
                  onChange: onChange,
                  error: error !== undefined,
                  helperText: error && REQUIRED_FIELD
                }));
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              height: '5.5rem',
              flex: '0.45 1 0'
            },
            className: (OrderPreferences_module_default()).box,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
              control: control,
              name: "profession",
              defaultValue: "",
              rules: {
                required: invoiceUse
              },
              render: function render(_ref3) {
                var _ref3$field = _ref3.field,
                    ref = _ref3$field.ref,
                    onChange = _ref3$field.onChange,
                    field = (0,objectWithoutProperties/* default */.Z)(_ref3$field, _excluded2),
                    error = _ref3.fieldState.error;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, OrderInvoiceForm_objectSpread(OrderInvoiceForm_objectSpread({}, field), {}, {
                  label: "\u0395\u03C0\u03AC\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1",
                  fullWidth: true,
                  variant: "outlined",
                  onChange: onChange,
                  error: error !== undefined,
                  helperText: error && REQUIRED_FIELD
                }));
              }
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (OrderPreferences_module_default()).invoiceInputContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              height: '5.5rem',
              flex: '0.45 1 0'
            },
            className: (OrderPreferences_module_default()).box,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
              control: control,
              name: "AFM",
              defaultValue: "",
              rules: {
                required: invoiceUse,
                pattern: /\d{9}/
              },
              render: function render(_ref4) {
                var _ref4$field = _ref4.field,
                    ref = _ref4$field.ref,
                    onChange = _ref4$field.onChange,
                    field = (0,objectWithoutProperties/* default */.Z)(_ref4$field, _excluded3),
                    error = _ref4.fieldState.error;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, OrderInvoiceForm_objectSpread(OrderInvoiceForm_objectSpread({}, field), {}, {
                  label: "\u0391\u03A6\u039C",
                  fullWidth: true,
                  variant: "outlined",
                  onChange: onChange,
                  error: error !== undefined,
                  helperText: error && errorMessages.AFM[error.type]
                }));
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              height: '5.5rem',
              flex: '0.45 1 0'
            },
            className: (OrderPreferences_module_default()).box,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
              control: control,
              name: "DOY",
              defaultValue: "",
              rules: {
                required: invoiceUse
              },
              render: function render(_ref5) {
                var _ref5$field = _ref5.field,
                    ref = _ref5$field.ref,
                    onChange = _ref5$field.onChange,
                    field = (0,objectWithoutProperties/* default */.Z)(_ref5$field, _excluded4),
                    error = _ref5.fieldState.error;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, OrderInvoiceForm_objectSpread(OrderInvoiceForm_objectSpread({}, field), {}, {
                  label: "\u0394\u039F\u03A5",
                  fullWidth: true,
                  variant: "outlined",
                  onChange: onChange,
                  error: error !== undefined,
                  helperText: error && REQUIRED_FIELD
                }));
              }
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (OrderPreferences_module_default()).invoiceInputContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              height: '5.5rem',
              flex: '0.45 1 0'
            },
            className: (OrderPreferences_module_default()).box,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
              control: control,
              name: "companyAddress",
              defaultValue: "",
              rules: {
                required: invoiceUse
              },
              render: function render(_ref6) {
                var _ref6$field = _ref6.field,
                    ref = _ref6$field.ref,
                    onChange = _ref6$field.onChange,
                    field = (0,objectWithoutProperties/* default */.Z)(_ref6$field, _excluded5),
                    error = _ref6.fieldState.error;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, OrderInvoiceForm_objectSpread(OrderInvoiceForm_objectSpread({}, field), {}, {
                  label: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7",
                  fullWidth: true,
                  variant: "outlined",
                  onChange: onChange,
                  error: error !== undefined,
                  helperText: error && REQUIRED_FIELD
                }));
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
              height: '5.5rem',
              flex: '0.45 1 0'
            },
            className: (OrderPreferences_module_default()).box,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
              control: control,
              name: "companyPhone",
              defaultValue: "",
              rules: {
                required: invoiceUse,
                pattern: /^\d{10}$/i
              },
              render: function render(_ref7) {
                var _ref7$field = _ref7.field,
                    ref = _ref7$field.ref,
                    onChange = _ref7$field.onChange,
                    field = (0,objectWithoutProperties/* default */.Z)(_ref7$field, _excluded6),
                    error = _ref7.fieldState.error;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, OrderInvoiceForm_objectSpread(OrderInvoiceForm_objectSpread({}, field), {}, {
                  label: "\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2",
                  variant: "outlined",
                  fullWidth: true,
                  onChange: onChange,
                  error: error !== undefined,
                  helperText: error && errorMessages.companyPhone[error.type],
                  inputProps: {
                    inputMode: 'numeric',
                    pattern: '[0-9]*'
                  }
                }));
              }
            })
          })]
        })]
      })
    })]
  });
}

/* harmony default export */ var OrderFormComponents_OrderInvoiceForm = (OrderInvoiceForm);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.browser.esm.js + 15 modules
var react_select_browser_esm = __webpack_require__(25397);
// EXTERNAL MODULE: ./src/components/GenericModal/GenericModal.jsx
var GenericModal = __webpack_require__(49875);
// EXTERNAL MODULE: ./src/components/PaymentMethodModal/PaymentMethodModal.module.scss
var PaymentMethodModal_module = __webpack_require__(12185);
var PaymentMethodModal_module_default = /*#__PURE__*/__webpack_require__.n(PaymentMethodModal_module);
;// CONCATENATED MODULE: ./src/components/PaymentMethodModal/PaymentMethodModal.jsx


function PaymentMethodModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function PaymentMethodModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PaymentMethodModal_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PaymentMethodModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function PaymentMethodModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      paymentMethods = _ref.paymentMethods,
      selectedOption = _ref.selectedOption,
      onSelect = _ref.onSelect;

  function onElementSelected(option) {
    onSelect(option);
    setIsOpen(false);
  }

  var modal = {
    isOpen: isOpen,
    closeModal: setIsOpen,
    headerClass: (PaymentMethodModal_module_default()).modalHeader,
    customStyles: {
      overlay: PaymentMethodModal_objectSpread({}, modalStyle/* default.overlay */.Z.overlay),
      content: {
        width: '41.5rem'
      }
    },
    bodyOverwrite: 'fullBody',
    isFullscreen: true,
    navigation: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u0395\u03C0\u03AF\u03BB\u03B5\u03BE\u03B5 \u03C4\u03C1\u03CC\u03C0\u03BF \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2"
    }, 1)],
    view: 'Slots',
    body: {
      Slots: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PaymentMethodModal_module_default()).container,
        children: paymentMethods && paymentMethods.map(function (option) {
          var _option$datacashRefer;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
            className: classnames_default()((PaymentMethodModal_module_default()).option, (0,defineProperty/* default */.Z)({}, (PaymentMethodModal_module_default()).selectedOption, (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.text) === option.text && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.datacashReference) === option.datacashReference)),
            onClick: function onClick() {
              return onElementSelected(option);
            },
            children: [option.value === 'cash' && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/assets/global/euro.svg",
              alt: "cash"
            }), option.value === 'card' && option.cardScheme && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/assets/global/".concat(option.cardScheme.toLowerCase().split(' ')[0], ".svg"),
              className: (PaymentMethodModal_module_default()).paymentMethodImg,
              alt: option.cardScheme
            }), option.datacashReference === '' && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/assets/global/newCard.png",
              alt: "new card"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: option.text
            })]
          }, (_option$datacashRefer = option.datacashReference) !== null && _option$datacashRefer !== void 0 ? _option$datacashRefer : option.value);
        })
      })
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GenericModal["default"], {
    modal: modal
  });
}
;// CONCATENATED MODULE: ./src/components/OrderDeliveryForm/UserPaymentOptions.jsx



function UserPaymentOptions_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function UserPaymentOptions_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { UserPaymentOptions_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { UserPaymentOptions_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var style = {
  control: function control(base) {
    return UserPaymentOptions_objectSpread(UserPaymentOptions_objectSpread({}, base), {}, {
      backgroundColor: OrderPreferences_module.bgColor,
      outline: 'none',
      border: 'none',
      '&:hover': {
        borderBottom: "2px solid  ".concat(OrderPreferences_module.brandColor)
      },
      borderBottom: "2px solid ".concat(OrderPreferences_module.brandColor)
    });
  },
  valueContainer: function valueContainer(base) {
    return UserPaymentOptions_objectSpread(UserPaymentOptions_objectSpread({}, base), {}, {
      padding: '0'
    });
  },
  singleValue: function singleValue(base) {
    return UserPaymentOptions_objectSpread({}, base);
  },
  dropdownIndicator: function dropdownIndicator(base, state) {
    return UserPaymentOptions_objectSpread(UserPaymentOptions_objectSpread({}, base), {}, {
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
      color: OrderPreferences_module.brandColor
    });
  },
  option: function option(_styles) {
    return UserPaymentOptions_objectSpread(UserPaymentOptions_objectSpread({}, _styles), {}, {
      color: OrderPreferences_module.bodyDefault
    });
  }
};
var CASH_OPTION = {
  value: 'cash',
  label: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: (OrderPreferences_module_default()).paymentMethodImg,
      src: "/assets/global/euro.svg",
      alt: "cash"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "\u039C\u03B5 \u03BC\u03B5\u03C4\u03C1\u03B7\u03C4\u03AC \u03AE POS \u03C3\u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03BB\u03B1\u03B2\u03AE"
    })]
  }),
  text: 'Με μετρητά ή POS στην παραλαβή'
};
var NEW_PAYMENT_CARD_OPTION = [{
  value: 'card',
  label: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: (OrderPreferences_module_default()).paymentMethodImg,
      src: "/assets/global/newCard.png",
      alt: "new card"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: "Online \u03BC\u03B5 \u03BD\u03AD\u03B1 \u03BA\u03AC\u03C1\u03C4\u03B1"
    })]
  }),
  text: 'Online με νέα κάρτα',
  datacashReference: ''
}];

function UserPaymentOptions() {
  var _useState = (0,react.useState)(),
      paymentMethods = _useState[0],
      setPaymentMethods = _useState[1];

  var _useState2 = (0,react.useState)(),
      paymentType = _useState2[0],
      setSelectedPaymentType = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isPaymentMethodModalVisible = _useState3[0],
      setIsPaymentMethodModalVisible = _useState3[1];

  (0,react.useEffect)(function () {
    var user$ = store_user/* default.subscribe */.Z.subscribe(function (user) {
      if (!(user !== null && user !== void 0 && user._id)) {
        setPaymentMethods([CASH_OPTION]);
        setSelectedPaymentType(CASH_OPTION);
        store_order/* Order.setPaymentType */.KM.setPaymentType('cash');
        return;
      }

      var newPaymentOption =  true ? NEW_PAYMENT_CARD_OPTION : 0;

      var createdPaymentMethods = function () {
        if (user.savedPaymentCards.length !== 0) {
          var paymentCards = user.savedPaymentCards.map(function (card) {
            return {
              value: 'card',
              label: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [card.cardScheme && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "/assets/global/".concat(card.cardScheme.toLowerCase().split(' ')[0], ".svg"),
                  className: (OrderPreferences_module_default()).paymentMethodImg,
                  alt: card.cardScheme
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: card.maskedNumber
                })]
              }),
              text: "".concat(card.maskedNumber),
              datacashReference: card._id,
              cardScheme: card.cardScheme
            };
          });
          return [CASH_OPTION].concat((0,toConsumableArray/* default */.Z)(paymentCards), (0,toConsumableArray/* default */.Z)(newPaymentOption));
        }

        return [CASH_OPTION].concat((0,toConsumableArray/* default */.Z)(newPaymentOption));
      }();

      setPaymentMethods(createdPaymentMethods);

      var _paymentMethods = function () {
        return (0,toConsumableArray/* default */.Z)(createdPaymentMethods);
      }();

      setPaymentMethods(_paymentMethods);
      setSelectedPaymentType(_paymentMethods[0]);
      store_order/* Order.setPaymentType */.KM.setPaymentType(_paymentMethods[0].value, _paymentMethods[0].datacashReference);
    });
    return function () {
      user$.unsubscribe();
    };
  }, []);

  function onChangePaymentMethod(typeSelected) {
    var _Order$getValue, _Order$getValue2;

    (0,analytics/* addPaymentMethod */.gP)((0,analytics/* getProductsCartInfo */.ez)((_Order$getValue = store_order/* Order.getValue */.KM.getValue()) === null || _Order$getValue === void 0 ? void 0 : _Order$getValue.products), Math.round((_Order$getValue2 = store_order/* Order.getValue */.KM.getValue()) === null || _Order$getValue2 === void 0 ? void 0 : _Order$getValue2.totalPrice) / 100, typeSelected === null || typeSelected === void 0 ? void 0 : typeSelected.value);
    setSelectedPaymentType(typeSelected);
    var datacashReference = typeSelected.datacashReference || null;
    store_order/* Order.setPaymentType */.KM.setPaymentType(typeSelected.value, datacashReference);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (OrderPreferences_module_default()).section,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (OrderPreferences_module_default()).preferencesTitle,
      children: "\u03A4\u03A1\u039F\u03A0\u039F\u03A3 \u03A0\u039B\u0397\u03A1\u03A9\u039C\u0397\u03A3"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (OrderPreferences_module_default()).instructions,
      children: "\u0395\u03C0\u03AF\u03BB\u03B5\u03BE\u03B5 \u03C0\u03C9\u03C2 \u03B8\u03B1 \u03B5\u03BE\u03BF\u03C6\u03BB\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 \u03C3\u03BF\u03C5"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (OrderPreferences_module_default()).paymentMethodModalContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
        type: "button",
        className: (OrderPreferences_module_default()).paymentMethodButton,
        onClick: function onClick() {
          setIsPaymentMethodModalVisible(true);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: paymentType === null || paymentType === void 0 ? void 0 : paymentType.label
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdKeyboardArrowDown */.Ix0, {
          className: (OrderPreferences_module_default()).imgDropdown,
          alt: "arrow"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PaymentMethodModal, {
        isOpen: isPaymentMethodModalVisible,
        setIsOpen: setIsPaymentMethodModalVisible,
        paymentMethods: paymentMethods,
        selectedOption: paymentType,
        onSelect: onChangePaymentMethod
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (OrderPreferences_module_default()).paymentMethodSelectContainer,
      "data-cy": "payment-method",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
        htmlFor: "paymentMethod",
        className: (OrderPreferences_module_default()).paymentMethodLabel,
        children: ["\u03A4\u03C1\u03CC\u03C0\u03BF\u03C2 \u03A0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (OrderPreferences_module_default()).labelAsterisk,
          children: "*"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
        name: "paymentMethod",
        inputId: "paymentMethod",
        options: paymentMethods,
        onChange: onChangePaymentMethod,
        styles: style,
        className: (OrderPreferences_module_default()).paymentMethodSelect,
        placeholder: "",
        value: paymentType,
        components: {
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        },
        theme: function theme(_theme) {
          return UserPaymentOptions_objectSpread(UserPaymentOptions_objectSpread({}, _theme), {}, {
            borderRadius: 0,
            colors: UserPaymentOptions_objectSpread(UserPaymentOptions_objectSpread({}, _theme.colors), {}, {
              primary: OrderPreferences_module.bgColor,
              primary25: OrderPreferences_module.bgColor
            })
          });
        }
      })]
    })]
  });
}

/* harmony default export */ var OrderDeliveryForm_UserPaymentOptions = (UserPaymentOptions);
;// CONCATENATED MODULE: ./src/components/OrderDeliveryForm/OrderPreferences.jsx


















var phoneCommunication = {
  value: 'phone',
  label: 'Τηλεφωνική επικοινωνία, θα σε καλέσουμε να επιλέξουμε μαζί το προϊόν αντικατάστασης'
};
var smartReplace = {
  value: 'replace',
  label: 'Έξυπνη αντικατάσταση, θα αντικαταστήσουμε το προϊόν με ένα αντίστοιχης ποιότητας και αξίας'
};
var noChange = {
  value: 'none',
  label: 'Καμία αλλαγή, θα αφαιρέσουμε το προϊόν από την παραγγελία σου και το τελικό κόστος'
};

function OrderPreferences(_ref) {
  var _ref$bagsInfo = _ref.bagsInfo,
      bagsInfo = _ref$bagsInfo === void 0 ? {} : _ref$bagsInfo,
      control = _ref.control,
      couponNo = _ref.couponNo;

  var _useState = (0,react.useState)(true),
      bagsUse = _useState[0],
      setBagsUse = _useState[1];

  var _useState2 = (0,react.useState)(false),
      pointsUse = _useState2[0],
      setPointsUse = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      bagsDisabled = _useState3[0],
      setBagsDisabled = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      pointsDisabled = _useState4[0],
      setPointsDisabled = _useState4[1];

  var _useState5 = (0,react.useState)(undefined),
      service = _useState5[0],
      setService = _useState5[1];

  var _useState6 = (0,react.useState)(0),
      wordCount = _useState6[0],
      setWordCount = _useState6[1];

  var _useState7 = (0,react.useState)('phone'),
      changesOption = _useState7[0],
      setChangesOption = _useState7[1];

  var _useState8 = (0,react.useState)({}),
      guestUser = _useState8[0],
      setGuestUser = _useState8[1];

  function onChangeChangesAllowed(option) {
    setChangesOption(option.target.value);
    store_order/* Order.setChangesAllowed */.KM.setChangesAllowed(option.target.value);
  }

  function onChangePointsUse() {
    setPointsUse(!pointsUse);
    store_order/* Order.setPointsUse */.KM.setPointsUse(!pointsUse);
  }

  function onChangePlasticBags() {
    store_order/* Order.setPlasticBags */.KM.setPlasticBags(!bagsUse);
    setBagsUse(!bagsUse); // TODO: use a single source of truth
  }

  function onChangeComment(e) {
    store_order/* Order.setComments */.KM.setComments(e.target.value);
    setWordCount(e.target.value.length);
  }

  (0,react.useEffect)(function () {
    store_order/* Order.setChangesAllowed */.KM.setChangesAllowed('phone');
    store_order/* Order.setPlasticBags */.KM.setPlasticBags(true);
    store_order/* Order.setComments */.KM.setComments(undefined);
    var deliveryMode$ = store_deliveryMode/* default.subscribe */.Z.subscribe(function (mode) {
      setService(mode);

      if (mode === 'express') {
        setBagsDisabled(true);
      }
    });
    var user$ = store_user/* default.subscribe */.Z.subscribe(function (user) {
      if (isEmpty_default()(user)) {
        return;
      }

      if (user.points < user.redeemPoints) {
        setPointsDisabled(true);
      }
    });
    var guestUser$ = store_guestUser/* default.subscribe */.Z.subscribe(function (_guestUser) {
      setGuestUser(_guestUser);
    });
    return function () {
      deliveryMode$.unsubscribe();
      user$.unsubscribe();
      guestUser$.unsubscribe();
    };
  }, []);
  var bagPrice = bagsInfo.price ? big_default()(bagsInfo.price).div(bagsInfo.amount || 1).div(100) : 0.1;
  var bagPriceText = "".concat(bagPrice.toFixed(2), "  \u20AC");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OrderDeliveryForm_UserPaymentOptions, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: (OrderPreferences_module_default()).section,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: (OrderPreferences_module_default()).preferencesTitle,
        children: "\u03A0\u03A1\u039F\u03A4\u0399\u039C\u0397\u03A3\u0395\u0399\u03A3 \u03A0\u0391\u03A1\u0391\u0393\u0393\u0395\u039B\u0399\u0391\u03A3"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (OrderPreferences_module_default()).instructions,
        children: "\u03A3\u03C5\u03BC\u03C0\u03BB\u03AE\u03C1\u03C9\u03C3\u03B5 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C4\u03B9\u03BC\u03AE\u03C3\u03B5\u03B9\u03C2 \u03C3\u03BF\u03C5 \u03C3\u03C7\u03B5\u03C4\u03B9\u03BA\u03AC \u03BC\u03B5 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1 \u03C3\u03BF\u03C5"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (OrderPreferences_module_default()).checkBoxContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OrderPreferences_module_default()).labelText,
          children: "\u038C\u03C4\u03B1\u03BD \u03B4\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD \u03B5\u03C0\u03B9\u03B8\u03C5\u03BC\u03B5\u03AF\u03C2:"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (OrderPreferences_module_default()).radioContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "radio",
            name: "radioCommunication",
            id: "radioCommunication",
            checked: changesOption === phoneCommunication.value,
            value: phoneCommunication.value,
            onChange: onChangeChangesAllowed,
            className: (OrderPreferences_module_default()).radioOption
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "radioCommunication",
            className: (OrderPreferences_module_default()).radioLabel,
            children: phoneCommunication.label
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (OrderPreferences_module_default()).radioContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "radio",
            name: "radioReplace",
            id: "radioReplace",
            checked: changesOption === smartReplace.value,
            value: smartReplace.value,
            onChange: onChangeChangesAllowed,
            className: (OrderPreferences_module_default()).radioOption
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "radioReplace",
            className: (OrderPreferences_module_default()).radioLabel,
            children: smartReplace.label
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (OrderPreferences_module_default()).radioContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "radio",
            name: "noChange",
            id: "noChange",
            checked: changesOption === noChange.value,
            value: noChange.value,
            onChange: onChangeChangesAllowed,
            className: (OrderPreferences_module_default()).radioOption
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "noChange",
            className: (OrderPreferences_module_default()).radioLabel,
            children: noChange.label
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (OrderPreferences_module_default()).checkBoxContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          className: (OrderPreferences_module_default()).checkBoxLabel,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: classnames_default()((OrderPreferences_module_default()).labelText, (0,defineProperty/* default */.Z)({}, (OrderPreferences_module_default()).opacity, guestUser === null || guestUser === void 0 ? void 0 : guestUser.email)),
            children: ["\u0395\u03BE\u03B1\u03C1\u03B3\u03CD\u03C1\u03C9\u03C3\u03B7 \u03C0\u03CC\u03BD\u03C4\u03C9\u03BD", ' ', (guestUser === null || guestUser === void 0 ? void 0 : guestUser.email) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              title: "\u039A\u03AC\u03BD\u03B5 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03BA\u03B1\u03B9 \u03B5\u03BE\u03B1\u03C1\u03B3\u03CD\u03C1\u03C9\u03C3\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03C0\u03CC\u03BD\u03C4\u03BF\u03C5\u03C2 \u03C3\u03BF\u03C5",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ai_index_esm/* AiFillInfoCircle */.kA6, {
                className: (OrderPreferences_module_default()).infoIcon
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_switch["default"], {
            disabled: pointsDisabled || Boolean(guestUser === null || guestUser === void 0 ? void 0 : guestUser.email),
            checked: pointsUse,
            onChange: onChangePointsUse,
            onColor: OrderPreferences_module.brandColorMuted,
            onHandleColor: OrderPreferences_module.brandColor,
            handleDiameter: 20,
            height: 14,
            width: 32,
            uncheckedIcon: false,
            checkedIcon: false,
            boxShadow: OrderPreferences_module.boxShadow,
            activeBoxShadow: OrderPreferences_module.boxShadow,
            className: "react-switch"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: classnames_default()((OrderPreferences_module_default()).details, (0,defineProperty/* default */.Z)({}, (OrderPreferences_module_default()).opacity, guestUser === null || guestUser === void 0 ? void 0 : guestUser.email)),
          children: "\u03A3\u03B1\u03C2 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03BD\u03BF\u03C5\u03BC\u03B5 \u03CC\u03C4\u03B9 \u03C4\u03BF \u03BA\u03B1\u03C4\u03CE\u03C4\u03B5\u03C1\u03BF \u03CC\u03C1\u03B9\u03BF \u03B5\u03BE\u03B1\u03C1\u03B3\u03CD\u03C1\u03C9\u03C3\u03B7\u03C2 \u03C0\u03CC\u03BD\u03C4\u03C9\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 500 \u03C0\u03CC\u03BD\u03C4\u03BF\u03B9"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderFormComponents_OrderCouponForm, {
        control: control,
        couponNo: couponNo,
        guestUser: guestUser
      }),  true && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderFormComponents_OrderInvoiceForm, {
        control: control
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (OrderPreferences_module_default()).checkBoxContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          htmlFor: "",
          className: (OrderPreferences_module_default()).checkBoxLabel,
          "data-cy": "plastic-bags-switch",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (OrderPreferences_module_default()).labelText,
            children: "\u0395\u03C0\u03B9\u03B8\u03C5\u03BC\u03CE \u03C3\u03B1\u03BA\u03BF\u03CD\u03BB\u03B5\u03C2 \u03BC\u03B5 \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_switch["default"], {
            disabled: bagsDisabled,
            checked: bagsUse,
            onChange: onChangePlasticBags,
            onColor: OrderPreferences_module.brandColorMuted,
            onHandleColor: OrderPreferences_module.brandColor,
            handleDiameter: 20,
            uncheckedIcon: false,
            checkedIcon: false,
            boxShadow: OrderPreferences_module.boxShadow,
            activeBoxShadow: OrderPreferences_module.boxShadow,
            className: "react-switch",
            height: 14,
            width: 32
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (OrderPreferences_module_default()).details,
          children: [service === 'express' && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "\u0397 \u03C7\u03C1\u03AE\u03C3\u03B7 \u03C3\u03B1\u03BA\u03BF\u03CD\u03BB\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C0\u03B1\u03C1\u03B1\u03AF\u03C4\u03B7\u03C4\u03B7 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7 \u03C4\u03B7\u03C2 Express \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03C3\u03BF\u03C5."
          }), bagsUse ? /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: [bagsInfo.amount, ' ', "B\u03B9\u03BF\u03B4\u03B9\u03B1\u03C3\u03C0\u03CE\u03BC\u03B5\u03BD".concat(bagsInfo.amount > 1 ? 'ες' : 'η', " \u03C3\u03B1\u03BA\u03BF\u03CD\u03BB").concat(bagsInfo.amount > 1 ? 'ες' : 'α'), ' ', "(\u03C0\u03B5\u03C1\u03B9\u03B2\u03B1\u03BB\u03BB\u03BF\u03BD\u03C4\u03B9\u03BA\u03CC \u03C4\u03AD\u03BB\u03BF\u03C2 ", bagPriceText, "/\u03C3\u03B1\u03BA\u03BF\u03CD\u03BB\u03B1)"]
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["B\u03B9\u03BF\u03B4\u03B9\u03B1\u03C3\u03C0\u03CE\u03BC\u03B5\u03BD\u03B5\u03C2 \u03C3\u03B1\u03BA\u03BF\u03CD\u03BB\u03B5\u03C2 ", bagPriceText, "/\u03C4\u03BC\u03C7, \u03BA\u03B1\u03C4\u03B1\u03C3\u03BA\u03B5\u03C5\u03B1\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03B1\u03C0\u03CC \u03C5\u03BB\u03B9\u03BA\u03CC 100% \u03C6\u03C5\u03C4\u03B9\u03BA\u03AE\u03C2 \u03C0\u03C1\u03BF\u03AD\u03BB\u03B5\u03C5\u03C3\u03B7\u03C2."]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          htmlFor: "comments",
          className: (OrderPreferences_module_default()).textAreaLabel,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (OrderPreferences_module_default()).labelText,
            children: "\u03A3\u03C7\u03CC\u03BB\u03B9\u03B1 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
            name: "comments",
            id: "comments",
            className: (OrderPreferences_module_default()).textArea,
            onChange: onChangeComment
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (OrderPreferences_module_default()).wordCountText,
            children: "".concat(wordCount, " / 500")
          })]
        })
      })]
    })]
  });
}

/* harmony default export */ var OrderDeliveryForm_OrderPreferences = (OrderPreferences);
;// CONCATENATED MODULE: ./src/components/OrderDeliveryForm/ShopPicker.jsx






function ShopPicker(_ref) {
  var _selectedShop$takeAwa;

  var setOpenTakeAwayModal = _ref.setOpenTakeAwayModal;

  var _useState = (0,react.useState)([]),
      selectedShop = _useState[0],
      setSelectedShop = _useState[1];

  (0,react.useEffect)(function () {
    var shop$ = store_shop/* Shop.subscribe */.k3.subscribe(setSelectedShop);
    return function () {
      shop$.unsubscribe();
    };
  }, []);
  if (!(selectedShop !== null && selectedShop !== void 0 && (_selectedShop$takeAwa = selectedShop.takeAwayShop) !== null && _selectedShop$takeAwa !== void 0 && _selectedShop$takeAwa.address)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (AddressPicker_module_default()).section,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (AddressPicker_module_default()).addressTitle,
      children: "\u039A\u0391\u03A4\u0391\u03A3\u03A4\u0397\u039C\u0391 \u03A0\u0391\u03A1\u0391\u039B\u0391\u0392\u0397\u03A3"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (AddressPicker_module_default()).instructions,
      children: "\u0395\u03C0\u03AF\u03BB\u03B5\u03BE\u03B5 \u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1 \u03B1\u03C0\u03CC \u03C4\u03BF \u03BF\u03C0\u03BF\u03AF\u03BF \u03B8\u03B1 \u03C0\u03B1\u03C1\u03B1\u03BB\u03AC\u03B2\u03B5\u03B9\u03C2 \u03C4\u03B9\u03C2 \u03B1\u03B3\u03BF\u03C1\u03AD\u03C2 \u03C3\u03BF\u03C5."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (AddressPicker_module_default()).addressContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (AddressPicker_module_default()).storeInfo,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/assets/".concat("kritikos", "/store.png"),
          className: (AddressPicker_module_default()).addressStore,
          alt: ""
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (AddressPicker_module_default()).addressDetails,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (AddressPicker_module_default()).addressType,
            children: selectedShop === null || selectedShop === void 0 ? void 0 : selectedShop.takeAwayShop.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "".concat(selectedShop === null || selectedShop === void 0 ? void 0 : selectedShop.takeAwayShop.address.street, "\n              ").concat(selectedShop === null || selectedShop === void 0 ? void 0 : selectedShop.takeAwayShop.address.streetNo, ",\n              ").concat(selectedShop === null || selectedShop === void 0 ? void 0 : selectedShop.takeAwayShop.address.postalCode, ",\n              ").concat(selectedShop === null || selectedShop === void 0 ? void 0 : selectedShop.takeAwayShop.address.city)
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: selectedShop === null || selectedShop === void 0 ? void 0 : selectedShop.takeAwayShop.phone
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (AddressPicker_module_default()).btnContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* SecondaryButton */.kq, {
          onClick: function onClick() {
            return setOpenTakeAwayModal(true);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (AddressPicker_module_default()).buttonText,
            children: "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u039A\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2"
          })
        })
      })]
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/tap.js + 1 modules
var tap = __webpack_require__(12368);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/distinctUntilKeyChanged.js
var distinctUntilKeyChanged = __webpack_require__(65562);
// EXTERNAL MODULE: ./src/api/Shops.js + 1 modules
var Shops = __webpack_require__(71432);
// EXTERNAL MODULE: ./src/components/OrderAlertModal/OrderAlertModal.jsx
var OrderAlertModal = __webpack_require__(26452);
// EXTERNAL MODULE: ./src/components/TimeSlotModal/TimeSlotModal.module.scss
var TimeSlotModal_module = __webpack_require__(56117);
var TimeSlotModal_module_default = /*#__PURE__*/__webpack_require__.n(TimeSlotModal_module);
;// CONCATENATED MODULE: ./src/components/TimeSlotModal/TimeSlotModal.jsx


function TimeSlotModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TimeSlotModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TimeSlotModal_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TimeSlotModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function TimeSlotModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      title = _ref.title,
      options = _ref.options,
      selectedOption = _ref.selectedOption,
      onSelect = _ref.onSelect;

  function onElementSelected(option) {
    onSelect(option);
    setIsOpen(false);
  }

  var modal = {
    isOpen: isOpen,
    headerClass: (TimeSlotModal_module_default()).modalHeader,
    closeModal: setIsOpen,
    customStyles: {
      overlay: TimeSlotModal_objectSpread({}, modalStyle/* default.overlay */.Z.overlay),
      content: {
        width: '41.50rem'
      }
    },
    bodyOverwrite: 'fullBody',
    isFullscreen: true,
    navigation: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: title
    }, 1)],
    view: 'Slots',
    body: {
      Slots: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (TimeSlotModal_module_default()).container,
        children: options && options.map(function (option) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: classnames_default()((TimeSlotModal_module_default()).option, (0,defineProperty/* default */.Z)({}, (TimeSlotModal_module_default()).selectedOption, (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) === option.label)),
            onClick: function onClick() {
              return onElementSelected(option);
            },
            disabled: option.isDisabled === true,
            children: option.label
          }, option.label);
        })
      })
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GenericModal["default"], {
    modal: modal
  });
}
// EXTERNAL MODULE: ./src/components/OrderDeliveryForm/TimeSlotsMobile.module.scss
var TimeSlotsMobile_module = __webpack_require__(11470);
var TimeSlotsMobile_module_default = /*#__PURE__*/__webpack_require__.n(TimeSlotsMobile_module);
;// CONCATENATED MODULE: ./src/components/OrderDeliveryForm/TimeSlotsMobile.jsx







function TimeSlotsMobile(_ref) {
  var selectedDay = _ref.selectedDay,
      onChangeSelectDay = _ref.onChangeSelectDay,
      selectOptionsDays = _ref.selectOptionsDays,
      selectedTime = _ref.selectedTime,
      onChangeSelectTimeslot = _ref.onChangeSelectTimeslot,
      selectOptionsSlotsByDay = _ref.selectOptionsSlotsByDay;

  var _useState = (0,react.useState)(false),
      isDaySlotVisible = _useState[0],
      setIsDaySlotVisible = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isTimeSlotVisible = _useState2[0],
      setIsTimeSlotVisible = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      dayError = _useState3[0],
      setDayError = _useState3[1];

  function showTimeSlotDialog() {
    if (selectedDay) {
      setIsTimeSlotVisible(true);
      return;
    }

    setDayError(true);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      type: "button",
      className: (TimeSlotsMobile_module_default()).slotButton,
      onClick: function onClick() {
        return setIsDaySlotVisible(true);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: selectedDay ? selectedDay.label : 'Επίλεξε ημέρα παράδοσης'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdKeyboardArrowDown */.Ix0, {
        className: (TimeSlotsMobile_module_default()).arrowIcon
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      type: "button",
      className: (TimeSlotsMobile_module_default()).slotButton,
      onClick: showTimeSlotDialog,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: selectedTime ? selectedTime.label : 'Επίλεξε ώρα παράδοσης'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdKeyboardArrowDown */.Ix0, {
        className: (TimeSlotsMobile_module_default()).arrowIcon
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TimeSlotModal, {
      title: "\u0395\u03C0\u03AF\u03BB\u03B5\u03BE\u03B5 \u03B7\u03BC\u03AD\u03C1\u03B1 \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7\u03C2",
      isOpen: isDaySlotVisible,
      setIsOpen: setIsDaySlotVisible,
      options: selectOptionsDays,
      selectedOption: selectedDay,
      onSelect: onChangeSelectDay
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TimeSlotModal, {
      title: "\u0395\u03C0\u03AF\u03BB\u03B5\u03BE\u03B5 \u03CE\u03C1\u03B1 \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7\u03C2",
      isOpen: isTimeSlotVisible,
      setIsOpen: setIsTimeSlotVisible,
      options: selectOptionsSlotsByDay,
      selectedOption: selectedTime,
      onSelect: onChangeSelectTimeslot
    }), dayError && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderAlertModal["default"], {
      alertText: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03C1\u03CE\u03C4\u03B1 \u03B7\u03BC\u03AD\u03C1\u03B1 \u03C0\u03B1\u03C1\u03AC\u03B4\u03BF\u03C3\u03B7\u03C2",
      isModalOpen: dayError !== null,
      callback: function callback() {
        setDayError(null);
      }
    })]
  });
}
// EXTERNAL MODULE: ./src/components/OrderDeliveryForm/TimeSlotsToDeliver.module.scss
var TimeSlotsToDeliver_module = __webpack_require__(45312);
var TimeSlotsToDeliver_module_default = /*#__PURE__*/__webpack_require__.n(TimeSlotsToDeliver_module);
;// CONCATENATED MODULE: ./src/components/OrderDeliveryForm/TimeSlotsToDeliver.jsx




















function TimeSlotsToDeliver(_ref) {
  var setPostalCodeUnsupported = _ref.setPostalCodeUnsupported;

  var _useState = (0,react.useState)(),
      order = _useState[0],
      setOrder = _useState[1];

  var _useState2 = (0,react.useState)(),
      user = _useState2[0],
      setUser = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      availableTimeSlots = _useState3[0],
      setAvailableTimeSlots = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      selectOptionsDays = _useState4[0],
      setSelectOptionsDays = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      selectOptionsSlotsByDay = _useState5[0],
      setSelectOptionsSlotsByDay = _useState5[1];

  var _useState6 = (0,react.useState)(''),
      selectedDay = _useState6[0],
      setSelectedDay = _useState6[1];

  var _useState7 = (0,react.useState)(''),
      selectedTime = _useState7[0],
      setSelectedTime = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      isModalOpen = _useState8[0],
      setOpenModal = _useState8[1];

  var _useState9 = (0,react.useState)(''),
      alertText = _useState9[0],
      setAlertText = _useState9[1];

  var modalLabel = 'Διαθεθιμότητα υπηρεσίας';
  var RESET_CHOSEN_TIMESLOTS = {
    timeSlotEnd: undefined,
    timeSlotStart: undefined
  };

  function timeSlotsToDays(timeSlots) {
    if (!timeSlots || timeSlots.length === 0) {
      return [];
    }

    var group = timeSlots.reduce(function (accumulator, currentValue) {
      var day = (0,dayjs/* formatUnixDate */.WE)(currentValue.timeSlotStart, 'DD-MM');
      accumulator[day] = [].concat((0,toConsumableArray/* default */.Z)(accumulator[day] || []), [currentValue]);
      return accumulator;
    }, {});
    return Object.values(group);
  }

  function titleDayMsg(i, start) {
    return (0,dayjs/* formatUnixDate */.WE)(start, 'dddd, DD MMM YYYY');
  }

  function createSelectOptions(slotsEasy, slotsExpress, slotsTakeAway, _service) {
    if (_service === 'easy') {
      if (slotsEasy.length) {
        var _selectOptionsDays = [];
        var selectOptionsSlots = [];
        slotsEasy.forEach(function (day, index) {
          _selectOptionsDays.push({
            value: day,
            label: titleDayMsg(index, day[0].timeSlotStart),
            index: index
          });

          day.forEach(function (slot) {
            selectOptionsSlots.push({
              value: slot,
              label: "".concat((0,dayjs/* formatUnixDate */.WE)(slot.timeSlotStart, 'HH:mm'), " - ").concat((0,dayjs/* formatUnixDate */.WE)(slot.timeSlotEnd, 'HH:mm')),
              isDisabled: !slot.isAvailable,
              timeSlotStart: slot.timeSlotStart
            });
          });
        });

        var _selectOptionsSlotsByDay = timeSlotsToDays(selectOptionsSlots);

        setSelectOptionsDays(_selectOptionsDays);
        setSelectOptionsSlotsByDay(_selectOptionsSlotsByDay);
        return;
      }

      setOpenModal(true);
      setAlertText('Η διεύθυνση που επέλεξες δυστυχώς δεν εξυπηρετείται ακόμα για αυτή την υπηρεσία.');
      return;
    }

    if (_service === 'express') {
      if (slotsExpress.length) {
        var _selectOptionsDays2 = [];
        var _selectOptionsSlots = [];
        slotsExpress.forEach(function (day, index) {
          _selectOptionsDays2.push({
            value: day,
            label: titleDayMsg(index, day[0].timeSlotStart),
            index: index
          });

          day.forEach(function (slot) {
            _selectOptionsSlots.push({
              value: slot,
              label: "".concat((0,dayjs/* formatUnixDate */.WE)(slot.timeSlotStart, 'HH:mm'), " - ").concat((0,dayjs/* formatUnixDate */.WE)(slot.timeSlotEnd, 'HH:mm')),
              isDisabled: !slot.isAvailable,
              timeSlotStart: slot.timeSlotStart
            });
          });
        });

        var _selectOptionsSlotsByDay2 = timeSlotsToDays(_selectOptionsSlots);

        setSelectOptionsDays(_selectOptionsDays2);
        setSelectOptionsSlotsByDay(_selectOptionsSlotsByDay2);
        return;
      }

      setOpenModal(true);
      setAlertText('Η διεύθυνση που επέλεξες δυστυχώς δεν εξυπηρετείται ακόμα για αυτή την υπηρεσία.');
      return;
    }

    if (_service === 'takeAway') {
      if (slotsTakeAway.length) {
        var _selectOptionsDays3 = [];
        var _selectOptionsSlots2 = [];
        slotsTakeAway.forEach(function (day, index) {
          _selectOptionsDays3.push({
            value: day,
            label: titleDayMsg(index, day[0].timeSlotStart),
            index: index
          });

          day.forEach(function (slot) {
            _selectOptionsSlots2.push({
              value: slot,
              label: "".concat((0,dayjs/* formatUnixDate */.WE)(slot.timeSlotStart, 'HH:mm'), " - ").concat((0,dayjs/* formatUnixDate */.WE)(slot.timeSlotEnd, 'HH:mm')),
              isDisabled: !slot.isAvailable,
              timeSlotStart: slot.timeSlotStart
            });
          });
        });

        var _selectOptionsSlotsByDay3 = timeSlotsToDays(_selectOptionsSlots2);

        setSelectOptionsDays(_selectOptionsDays3);
        setSelectOptionsSlotsByDay(_selectOptionsSlotsByDay3);
      }
    }
  }

  (0,react.useEffect)(function () {
    var user$ = store_user/* default.subscribe */.Z.subscribe(setUser);
    return function () {
      user$.unsubscribe();
    };
  }, []);
  (0,react.useEffect)(function () {
    var shop$ = store_shop/* Shop.subscribe */.k3.subscribe( /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(shop) {
        var _shop$takeAwayShop, _resTakeAway$timeslot;

        var selectedService, resTakeAway, daysTakeAway;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (shop !== null && shop !== void 0 && shop.takeAwayShop) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                selectedService = store_deliveryMode/* default.getValue */.Z.getValue();

                if (!(selectedService !== 'takeAway')) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                _context.next = 7;
                return (0,Shops/* getTimeslotsForTakeAwayShop */.L9)(shop === null || shop === void 0 ? void 0 : (_shop$takeAwayShop = shop.takeAwayShop) === null || _shop$takeAwayShop === void 0 ? void 0 : _shop$takeAwayShop._id);

              case 7:
                resTakeAway = _context.sent;

                if (resTakeAway !== null && resTakeAway !== void 0 && (_resTakeAway$timeslot = resTakeAway.timeslots) !== null && _resTakeAway$timeslot !== void 0 && _resTakeAway$timeslot.length) {
                  store_order/* Order.setShopId */.KM.setShopId(resTakeAway.timeslots[0].shopId);
                  setPostalCodeUnsupported(false);
                } else {
                  setPostalCodeUnsupported(true);
                }

                store_order/* Order.deleteProperty */.KM.deleteProperty(['addressObject']);
                daysTakeAway = timeSlotsToDays(resTakeAway.timeslots);
                setAvailableTimeSlots(daysTakeAway);
                createSelectOptions(null, null, daysTakeAway, selectedService);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    var order$ = store_order/* Order.subject.pipe */.KM.subject.pipe((0,tap/* tap */.b)(function (_order) {
      return setOrder(_order);
    }), (0,filter/* filter */.h)(function (_order) {
      return _order === null || _order === void 0 ? void 0 : _order.addressObject;
    }), (0,map/* map */.U)(function (_ref3) {
      var addressObject = _ref3.addressObject;
      return addressObject;
    }), (0,distinctUntilKeyChanged/* distinctUntilKeyChanged */.g)('postalCode')).subscribe( /*#__PURE__*/function () {
      var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref4) {
        var postalCode, selectedService, _resEasy$, resEasy, timeSlots, tempShopId, daysEasy, _resExpress$timeslots, resExpress, daysExpress;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                postalCode = _ref4.postalCode;
                selectedService = store_deliveryMode/* default.getValue */.Z.getValue();

                if (!(selectedService === 'takeAway')) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                store_order/* Order.setTimeslot */.KM.setTimeslot(RESET_CHOSEN_TIMESLOTS);

                if (!(selectedService === 'easy')) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 8;
                return (0,Shops/* getByPostalCode */.r4)(postalCode);

              case 8:
                resEasy = _context2.sent;
                timeSlots = resEasy === 404 ? [] : (_resEasy$ = resEasy[0]) === null || _resEasy$ === void 0 ? void 0 : _resEasy$.timeSlots;

                if (timeSlots !== null && timeSlots !== void 0 && timeSlots.length) {
                  tempShopId = resEasy[0]._id;
                  store_order/* Order.setShopId */.KM.setShopId(tempShopId);
                  setPostalCodeUnsupported(false);
                } else {
                  setPostalCodeUnsupported(true);
                }

                daysEasy = timeSlotsToDays(timeSlots);
                setAvailableTimeSlots(daysEasy);
                createSelectOptions(daysEasy, null, null, selectedService);
                return _context2.abrupt("return");

              case 15:
                if (!(selectedService === 'express')) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 18;
                return (0,Shops/* getTimeslots */.rS)(postalCode);

              case 18:
                resExpress = _context2.sent;

                if (resExpress !== null && resExpress !== void 0 && (_resExpress$timeslots = resExpress.timeslots) !== null && _resExpress$timeslots !== void 0 && _resExpress$timeslots.length) {
                  store_order/* Order.setShopId */.KM.setShopId(resExpress.timeslots[0].shopId);
                  setPostalCodeUnsupported(false);
                } else {
                  setPostalCodeUnsupported(true);
                }

                daysExpress = timeSlotsToDays(resExpress.timeslots);
                setAvailableTimeSlots(daysExpress);
                createSelectOptions(null, daysExpress, null, selectedService);

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());
    return function () {
      shop$.unsubscribe();
      order$.unsubscribe();
    };
  }, [user]);

  function onClickSelectTimeSlot(timeslot) {
    store_order/* Order.setTimeslot */.KM.setTimeslot(timeslot);
  }

  function onChangeSelectDay(day) {
    setSelectedDay(day);

    if (day && day.label !== selectedDay.label && selectedTime && selectOptionsSlotsByDay) {
      var _selectOptionsSlotsBy;

      var newTimeslot = (_selectOptionsSlotsBy = selectOptionsSlotsByDay[day.index]) === null || _selectOptionsSlotsBy === void 0 ? void 0 : _selectOptionsSlotsBy.find(function (_timeslot) {
        return _timeslot.label === selectedTime.label;
      });

      if (newTimeslot !== null && newTimeslot !== void 0 && newTimeslot.isDisabled) {
        setSelectedTime(null);
        store_order/* Order.setTimeslot */.KM.setTimeslot(RESET_CHOSEN_TIMESLOTS);
      }
    }
  }

  function onChangeSelectTimeslot(timeslot) {
    setSelectedTime(timeslot);
    store_order/* Order.setTimeslot */.KM.setTimeslot(timeslot.value);
  }

  if (!order) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (TimeSlotsToDeliver_module_default()).section,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (TimeSlotsToDeliver_module_default()).timeSlotsTitle,
      children: "\u03A9\u03A1\u0391 \u03A0\u0391\u03A1\u0391\u0394\u039F\u03A3\u0397\u03A3"
    }), !isEmpty_default()(availableTimeSlots[0]) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (TimeSlotsToDeliver_module_default()).instructions,
        children: "\u0395\u03C0\u03AF\u03BB\u03B5\u03BE\u03B5 \u03C4\u03B7 \u03B7\u03BC\u03AD\u03C1\u03B1 & \u03CE\u03C1\u03B1 \u03C0\u03BF\u03C5 \u03B8\u03AD\u03BB\u03B5\u03B9\u03C2 \u03BD\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B4\u03BF\u03B8\u03BF\u03CD\u03BD \u03BF\u03B9 \u03B1\u03B3\u03BF\u03C1\u03AD\u03C2 \u03C3\u03BF\u03C5 \u03B1\u03C0\u03CC \u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        role: "group",
        className: classnames_default()((TimeSlotsToDeliver_module_default()).selectionDayContainer, {}),
        children: availableTimeSlots.map(function (timeSlot, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((TimeSlotsToDeliver_module_default()).selectionDay),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (TimeSlotsToDeliver_module_default()).selectionDayHeader,
              children: titleDayMsg(index, timeSlot[0].timeSlotStart)
            }), timeSlot.map(function (slot) {
              var _cn;

              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  name: "timeSlot",
                  role: "radio",
                  "aria-checked": order.timeSlotStart === slot.timeSlotStart,
                  id: slot.timeSlotStart,
                  value: slot.timeSlotStart,
                  className: classnames_default()((TimeSlotsToDeliver_module_default()).timeSlotInput, (_cn = {}, (0,defineProperty/* default */.Z)(_cn, (TimeSlotsToDeliver_module_default()).disabledTimeslot, !slot.isAvailable), (0,defineProperty/* default */.Z)(_cn, (TimeSlotsToDeliver_module_default()).selectedTimeslot, order.timeSlotStart === slot.timeSlotStart), _cn)),
                  onClick: function onClick() {
                    return onClickSelectTimeSlot(slot);
                  },
                  disabled: !slot.isAvailable,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: (TimeSlotsToDeliver_module_default()).timeSlotLabel,
                    "data-cy": slot.isAvailable ? 'timeSlot-radio-active' : 'timeSlot-radio-disabled',
                    children: "".concat((0,dayjs/* formatUnixDate */.WE)(slot.timeSlotStart, 'HH:mm'), " -\n                      ").concat((0,dayjs/* formatUnixDate */.WE)(slot.timeSlotEnd, 'HH:mm'))
                  })
                })
              }, slot.timeSlotStart);
            })]
          }, timeSlot[0].timeSlotStart);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (TimeSlotsToDeliver_module_default()).selectContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TimeSlotsMobile, {
          selectedDay: selectedDay,
          onChangeSelectDay: onChangeSelectDay,
          selectOptionsDays: selectOptionsDays,
          selectedTime: selectedTime,
          onChangeSelectTimeslot: onChangeSelectTimeslot,
          selectOptionsSlotsByDay: selectOptionsSlotsByDay[selectedDay === null || selectedDay === void 0 ? void 0 : selectedDay.index]
        })
      })]
    }), isModalOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderAlertModal["default"], {
      alertText: alertText,
      isModalOpen: isModalOpen,
      modalLabel: modalLabel,
      setOpenModal: setOpenModal,
      callback: function callback() {
        return setOpenModal(false);
      }
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/OrderDeliveryForm/OrderDeliveryForm.jsx





function OrderDeliveryForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function OrderDeliveryForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { OrderDeliveryForm_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { OrderDeliveryForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




































var INITIAL_DELIVERY_MODE = '';
var DEFAULT_NO_TIMESLOT_SELLECTED_MESSAGE = 'Παρακαλώ επιλέξτε ώρα παράδοσης';
var DEFAULT_ERROR_MESSAGE = 'Κάτι πήγε στραβά. Η παραγγελία σας δεν ολοκληρώθηκε. Παρακαλώ προσπαθήστε ξανά.';
var DELIVERY_UNSUPPORTED_POSTAL_CODE_ERROR = 'Η περιοχή σου δεν εξυπηρετείται προς το παρόν. Μπορείς να περιηγηθείς στην εφαρμογή και να επιλέξεις άλλη διεύθυνση παράδοσης.';
var TAKEAWAY_UNSUPPORTED_POSTAL_CODE_ERROR = 'Προς το παρόν δεν υπάρχουν διαθέσιμες ημέρες ή ώρες παράδοσης για παραγγελίες. Παρακαλούμε δοκιμάστε αργότερα.';
function OrderDeliveryForm() {
  var _useState = (0,react.useState)(INITIAL_DELIVERY_MODE),
      deliveryMode = _useState[0],
      setDeliveryMode = _useState[1];

  var _useState2 = (0,react.useState)([]),
      takeAwayShops = _useState2[0],
      setTakeAwayShops = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      postalCodeUnsupported = _useState3[0],
      setPostalCodeUnsupported = _useState3[1];

  var _useState4 = (0,react.useState)({
    amount: 0,
    price: 0
  }),
      bagsInfo = _useState4[0],
      setBagsInfo = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isEligibleToRate = _useState5[0],
      setIsEligibleToRate = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isModalSuccessOpen = _useState6[0],
      setIsModalSuccessOpen = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isTakeAwayModalOpen = _useState7[0],
      setOpenTakeAwayModal = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      isAppRatingModalOpen = _useState8[0],
      setIsAppRatingModalOpen = _useState8[1];

  var _useState9 = (0,react.useState)({}),
      guestUser = _useState9[0],
      setGuestUser = _useState9[1];

  var _useState10 = (0,react.useState)(''),
      modalType = _useState10[0],
      setModalType = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      isConfirmationModalOpen = _useState11[0],
      setIsConfirmationModalOpen = _useState11[1];

  var _useState12 = (0,react.useState)(''),
      errorModalMessage = _useState12[0],
      setErrorModalMessage = _useState12[1];

  var _useState13 = (0,react.useState)(false),
      isProductChanges = _useState13[0],
      setIsProductChanges = _useState13[1];

  var _useState14 = (0,react.useState)([]),
      unavailableProducts = _useState14[0],
      setUnavailableProducts = _useState14[1];

  var _useState15 = (0,react.useState)([]),
      priceChangeProducts = _useState15[0],
      setPriceChangeProducts = _useState15[1];

  var _useState16 = (0,react.useState)(0),
      finalCartPrice = _useState16[0],
      setFinalCartPrice = _useState16[1];

  var _useState17 = (0,react.useState)(0),
      fee = _useState17[0],
      setFee = _useState17[1];

  var router = (0,next_router.useRouter)();
  var orderCheckResponse;

  var _useForm = (0,index_esm/* useForm */.cI)({
    mode: 'onBlur',
    shouldFocusError: true,
    defaultValues: {
      couponNo: '',
      AFM: '',
      DOY: '',
      companyAddress: '',
      companyName: '',
      companyPhone: '',
      profession: ''
    }
  }),
      control = _useForm.control,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  var couponNo = (0,index_esm/* useWatch */.qo)({
    control: control,
    name: 'couponNo'
  });
  (0,react.useEffect)(function () {
    if (store_guestUser/* default.getValue */.Z.getValue() || store_user/* default.getValue */.Z.getValue()) {
      if (cart/* createFromCart.getValue */.aY.getValue()) {
        cart/* createFromCart.update */.aY.update(false);
      } else {
        router.push('/cart', '/cart');
      }
    } else {
      router.push('/');
    }
  }, []);

  function onClickSelectStore(store) {
    setOpenTakeAwayModal(false);
    store_order/* Order.deleteProperty */.KM.deleteProperty(['timeSlotEnd', 'timeSlotStart', 'timeslotId']);
    store_order/* Order.setShopId */.KM.setShopId(store._id);
    var prevService = store_deliveryMode/* default.getValue */.Z.getValue();
    var prevShop = store_shop/* Shop.getValue */.k3.getValue();
    cart/* ValuesToBeUpdated.updateService */.vV.updateService(prevService);
    cart/* ValuesToBeUpdated.updateShop */.vV.updateShop(prevShop === null || prevShop === void 0 ? void 0 : prevShop.takeAwayShop);
    store_deliveryMode/* default.update */.Z.update('takeAway');
    store_shop/* Shop.setTakeAwayShop */.k3.setTakeAwayShop(store);
  }

  var EXPRESS_FEE = Number(300);
  var PENALTY_FEE = Number(300);
  var MIN_CART_TAKEAWAY = Number(1000);
  var MIN_CART_PRICE = Number(4000) || 4000;
  var alertTextExpress = "To \u03BA\u03CC\u03C3\u03C4\u03BF\u03C2 \u03C4\u03B7\u03C2 \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 ".concat(String((EXPRESS_FEE / 100).toFixed(2)), "\u20AC  \u03BA\u03B1\u03B9 \u03B8\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C4\u03B5\u03B8\u03B5\u03AF \u03C3\u03C4o \u03C3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03CC \u03C0\u03BF\u03C3\u03CC \u03C4\u03B7\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03C3\u03B1\u03C2.");
  var alertTextEasy = "\u0393\u03B9\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B5\u03C2 \u03BA\u03AC\u03C4\u03C9 \u03C4\u03C9\u03BD ".concat(String((MIN_CART_PRICE / 100).toFixed(2)), "\u20AC, \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03B5\u03C0\u03B9\u03B2\u03AC\u03C1\u03C5\u03BD\u03C3\u03B7 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03B9\u03BA\u03CE\u03BD ").concat(String((PENALTY_FEE / 100).toFixed(2)), "\u20AC. \u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5;");

  function handleCreateOrderError() {
    var userMessageServer = 'Η σύνδεσή σας στο ίντερνετ αντιμετωπίζει κάποιο πρόβλημα. Παρακαλούμε προσπαθήστε αργότερα.';
    setErrorModalMessage(userMessageServer);
    setModalType('genericErrorInfo');
    campaign/* default.update */.Z.update([]);
  }

  function onClickOkReceipt() {
    if (!isEligibleToRate || guestUser !== null && guestUser !== void 0 && guestUser.email) {
      return router.push('/');
    }

    setIsModalSuccessOpen(false);
    setIsAppRatingModalOpen(true);
  }

  function onSuccessfulRatingSubmit() {
    setTimeout(function () {
      router.push('/');
    }, 2500);
  }

  function onClickSubmit() {
    if (!store_order/* Order.getTimeSlotStart */.KM.getTimeSlotStart()) {
      setModalType('noTimeslot');
      setErrorModalMessage(DEFAULT_NO_TIMESLOT_SELLECTED_MESSAGE);
      return true;
    }

    return false;
  }

  function onSubmitOrder() {
    return _onSubmitOrder.apply(this, arguments);
  }

  function _onSubmitOrder() {
    _onSubmitOrder = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var price;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              price = cart/* cartPrice.getValue */.O0.getValue();
              console.debug('OrderDeliveryForm', 'onSubmitOrder', 'price:', price, 'deliveryMode', deliveryMode);

              if (!(deliveryMode === 'express')) {
                _context2.next = 6;
                break;
              }

              setErrorModalMessage(alertTextExpress);
              setIsConfirmationModalOpen(true);
              return _context2.abrupt("return");

            case 6:
              if (!(deliveryMode === 'easy' && price < MIN_CART_PRICE)) {
                _context2.next = 10;
                break;
              }

              setErrorModalMessage(alertTextEasy);
              setIsConfirmationModalOpen(true);
              return _context2.abrupt("return");

            case 10:
              if (!(deliveryMode === 'takeAway' && price < MIN_CART_TAKEAWAY)) {
                _context2.next = 13;
                break;
              }

              onAcceptCharges();
              return _context2.abrupt("return");

            case 13:
              onAcceptCharges();

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _onSubmitOrder.apply(this, arguments);
  }

  function onAcceptCharges() {
    return _onAcceptCharges.apply(this, arguments);
  }

  function _onAcceptCharges() {
    _onAcceptCharges = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var _currentOrder$coupon, _user$mobile, currentOrder, order, response, _response$error, _response$error$respo, _response$error$respo2, _response$error$respo3, userMessage, errorCode, _response$error2, _response$error2$resp, _response$error2$resp2, _response$error2$resp3, _response$error3, _response$error3$resp, _response$error3$resp2, _response$error3$resp3, _response$error3$resp4, userMessageError, disabledDiscountCampaignIds, _yield$getCampaigns, campaigns, error, service, collectionType, discountCampaignsApplied, _response$error4, _response$error4$resp, _response$error4$resp2, _response$error4$resp3, _response$error4$resp4, correctTotalPrice, correctTotalPriceFormatted, orderCreated, user, orderUpdated;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              loader/* default.addEvent */.Z.addEvent('SUBMIT_ORDER');
              _context3.prev = 1;
              setIsConfirmationModalOpen(false);
              currentOrder = store_order/* Order.getValue */.KM.getValue();
              order = OrderDeliveryForm_objectSpread(OrderDeliveryForm_objectSpread({}, currentOrder), {}, {
                user: {
                  phone: guestUser === null || guestUser === void 0 ? void 0 : guestUser.contactPhone,
                  email: guestUser === null || guestUser === void 0 ? void 0 : guestUser.email,
                  isGuestUser: Boolean(guestUser === null || guestUser === void 0 ? void 0 : guestUser.email)
                }
              });
              _context3.next = 7;
              return (0,orders/* createOrder */.LV)(order);

            case 7:
              response = _context3.sent;

              if (!response.error) {
                _context3.next = 44;
                break;
              }

              console.debug('OrderDeliveryForm', 'onAcceptCharges', 'response.error', JSON.stringify(response.error));
              userMessage = get_default()(response, 'error.response.data.error.userMessage', DEFAULT_ERROR_MESSAGE);
              errorCode = response === null || response === void 0 ? void 0 : (_response$error = response.error) === null || _response$error === void 0 ? void 0 : (_response$error$respo = _response$error.response) === null || _response$error$respo === void 0 ? void 0 : (_response$error$respo2 = _response$error$respo.data) === null || _response$error$respo2 === void 0 ? void 0 : (_response$error$respo3 = _response$error$respo2.error) === null || _response$error$respo3 === void 0 ? void 0 : _response$error$respo3.code;

              if (!(errorCode === 'ORDVD032')) {
                _context3.next = 33;
                break;
              }

              userMessageError = response === null || response === void 0 ? void 0 : (_response$error2 = response.error) === null || _response$error2 === void 0 ? void 0 : (_response$error2$resp = _response$error2.response) === null || _response$error2$resp === void 0 ? void 0 : (_response$error2$resp2 = _response$error2$resp.data) === null || _response$error2$resp2 === void 0 ? void 0 : (_response$error2$resp3 = _response$error2$resp2.error) === null || _response$error2$resp3 === void 0 ? void 0 : _response$error2$resp3.userMessage;
              disabledDiscountCampaignIds = response === null || response === void 0 ? void 0 : (_response$error3 = response.error) === null || _response$error3 === void 0 ? void 0 : (_response$error3$resp = _response$error3.response) === null || _response$error3$resp === void 0 ? void 0 : (_response$error3$resp2 = _response$error3$resp.data) === null || _response$error3$resp2 === void 0 ? void 0 : (_response$error3$resp3 = _response$error3$resp2.error) === null || _response$error3$resp3 === void 0 ? void 0 : (_response$error3$resp4 = _response$error3$resp3.params) === null || _response$error3$resp4 === void 0 ? void 0 : _response$error3$resp4.disabledDiscountCampaignIds;
              setErrorModalMessage(userMessageError);
              setModalType('genericErrorInfo');
              _context3.next = 19;
              return (0,Campaigns/* default */.Z)(true);

            case 19:
              _yield$getCampaigns = _context3.sent;
              campaigns = _yield$getCampaigns.campaigns;
              error = _yield$getCampaigns.error;

              if (!error) {
                _context3.next = 25;
                break;
              }

              handleCreateOrderError();
              return _context3.abrupt("return");

            case 25:
              service = store_deliveryMode/* default.getValue */.Z.getValue();
              collectionType = store_deliveryMode/* default.getCollectionAsNumber */.Z.getCollectionAsNumber(service);
              _context3.next = 29;
              return productsCollection/* default.updateCollection */.Z.updateCollection(collectionType);

            case 29:
              discountCampaignsApplied = order === null || order === void 0 ? void 0 : order.discountCampaignsApplied.filter(function (campaignID) {
                return !disabledDiscountCampaignIds.includes(campaignID);
              });
              store_order/* Order.setDiscountCampaignsApplied */.KM.setDiscountCampaignsApplied(discountCampaignsApplied);
              campaign/* default.update */.Z.update(campaigns);
              return _context3.abrupt("return");

            case 33:
              if (!(errorCode === 'ORDINT203')) {
                _context3.next = 41;
                break;
              }

              (0,esm/* captureMessage */.uT)( // eslint-disable-next-line max-len
              "Price missmatch:  finalCartPrice  ".concat(finalCartPrice, " bags Price  ").concat(bagsInfo.price, " fee  ").concat(fee, " deliveryMode  ").concat(deliveryMode));
              correctTotalPrice = response === null || response === void 0 ? void 0 : (_response$error4 = response.error) === null || _response$error4 === void 0 ? void 0 : (_response$error4$resp = _response$error4.response) === null || _response$error4$resp === void 0 ? void 0 : (_response$error4$resp2 = _response$error4$resp.data) === null || _response$error4$resp2 === void 0 ? void 0 : (_response$error4$resp3 = _response$error4$resp2.error) === null || _response$error4$resp3 === void 0 ? void 0 : (_response$error4$resp4 = _response$error4$resp3.params) === null || _response$error4$resp4 === void 0 ? void 0 : _response$error4$resp4.finalPrice;
              store_order/* Order.setTotalPrice */.KM.setTotalPrice(correctTotalPrice);
              correctTotalPriceFormatted = (correctTotalPrice / 100).toFixed(2);
              setErrorModalMessage("".concat(userMessage, " ").concat(correctTotalPriceFormatted, " \u20AC"));
              setIsConfirmationModalOpen(true);
              return _context3.abrupt("return");

            case 41:
              setErrorModalMessage(userMessage);
              setModalType('genericErrorInfo');
              return _context3.abrupt("return");

            case 44:
              orderCreated = response.order;
              user = store_user/* default.getValue */.Z.getValue();
              console.debug('OrderDeliveryForm', 'onAcceptCharges', 'orderCreated', orderCreated);
              (0,analytics/* purchase */.e_)((0,analytics/* getProductsCartInfo */.ez)(currentOrder.products), Math.round(currentOrder.totalPrice) / 100, Math.round(currentOrder.penaltyFee) / 100, currentOrder === null || currentOrder === void 0 ? void 0 : (_currentOrder$coupon = currentOrder.coupon) === null || _currentOrder$coupon === void 0 ? void 0 : _currentOrder$coupon.code, orderCreated === null || orderCreated === void 0 ? void 0 : orderCreated.friendlyId, {
                email: (user === null || user === void 0 ? void 0 : user.email) || '',
                phone_number: (user === null || user === void 0 ? void 0 : (_user$mobile = user.mobile) === null || _user$mobile === void 0 ? void 0 : _user$mobile.phone) || ''
              });

              if (!orderCreated.paymentUrl) {
                _context3.next = 52;
                break;
              }

              window.location = orderCreated.paymentUrl;
              console.debug('OrderDeliveryForm', 'window.location', window.location);
              return _context3.abrupt("return");

            case 52:
              orderUpdated = OrderDeliveryForm_objectSpread(OrderDeliveryForm_objectSpread({}, order), {}, {
                serverResponse: orderCreated
              });
              store_order/* Order.update */.KM.update(orderUpdated);
              cart/* default.reset */.ZP.reset();
              store_order/* CouponDiscount.update */.P8.update(0);
              setIsModalSuccessOpen(true);
              _context3.next = 62;
              break;

            case 59:
              _context3.prev = 59;
              _context3.t0 = _context3["catch"](1);
              console.error(_context3.t0); // TODO: show in error modal

            case 62:
              _context3.prev = 62;
              loader/* default.removeEvent */.Z.removeEvent('SUBMIT_ORDER');
              return _context3.finish(62);

            case 65:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 59, 62, 65]]);
    }));
    return _onAcceptCharges.apply(this, arguments);
  }

  function modifyProduct() {
    var allProducts = cart/* productsForOrder.getStorageValue */.cW.getStorageValue();
    var products = allProducts === null || allProducts === void 0 ? void 0 : allProducts.filter(function (p) {
      return !p.isSpecialOffer;
    });
    var offers = allProducts === null || allProducts === void 0 ? void 0 : allProducts.filter(function (p) {
      return p.isSpecialOffer;
    });
    var offersFiltered = offers === null || offers === void 0 ? void 0 : offers.filter(function (value, index, self) {
      var _self$map;

      return (self === null || self === void 0 ? void 0 : (_self$map = self.map(function (p) {
        return p._id;
      })) === null || _self$map === void 0 ? void 0 : _self$map.indexOf(value._id)) === index;
    });
    var productsFiltered = products === null || products === void 0 ? void 0 : products.filter(function (value, index, self) {
      var _self$map2;

      return (self === null || self === void 0 ? void 0 : (_self$map2 = self.map(function (p) {
        return p._id;
      })) === null || _self$map2 === void 0 ? void 0 : _self$map2.indexOf(value._id)) === index;
    });
    var modifiedProducts = productsFiltered === null || productsFiltered === void 0 ? void 0 : productsFiltered.map(function (p) {
      var finalPriceText = p.finalPrice;

      var quantity = cart/* productsQuantities.getValue */.UU.getValue()[p._id];

      return OrderDeliveryForm_objectSpread(OrderDeliveryForm_objectSpread({}, p), {}, {
        name: p.displayName,
        price: finalPriceText,
        quantity: quantity,
        comments: p.userComments
      });
    });
    var modifiedOffers = offersFiltered === null || offersFiltered === void 0 ? void 0 : offersFiltered.map(function (o) {
      if (o.products.length) {
        var finalPriceText = o.finalPrice;

        var quantity = cart/* productsQuantities.getValue */.UU.getValue()[o._id];

        return {
          _id: o._id,
          name: o.name,
          price: finalPriceText,
          quantity: quantity
        };
      }

      if (o.groups.length) {
        var _finalPriceText = o.finalPrice;

        var _quantity = cart/* productsQuantities.getValue */.UU.getValue()[o._id];

        var groups = o.groups.map(function (g) {
          return {
            _id: g._id,
            products: [{
              _id: g.products[0].productId,
              sku: g.products[0].sku
            }]
          };
        });
        return {
          _id: o._id,
          name: o.name,
          price: _finalPriceText,
          quantity: _quantity,
          groups: groups
        };
      }

      return null;
    });
    return [modifiedProducts, modifiedOffers];
  }

  function checkOrderOnCheckout(_x) {
    return _checkOrderOnCheckout.apply(this, arguments);
  }

  function _checkOrderOnCheckout() {
    _checkOrderOnCheckout = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(_currentOrder) {
      var _orderCheckResponse6, _orderCheckResponse6$;

      var _guestUser, currentOrder, _orderCheckResponse2, _orderCheckResponse2$, _orderCheckResponse2$2, _orderCheckResponse2$3, _orderCheckResponse3, _orderCheckResponse3$, _orderCheckResponse3$2, _orderCheckResponse3$3, _ref, errorCode, _ref2, userMessage, _orderCheckResponse4, _orderCheckResponse4$, _orderCheckResponse4$2, _orderCheckResponse4$3, _orderCheckResponse4$4, disabledDiscountCampaignIds, _yield$getCampaigns2, campaigns, error, service, collectionType, discountCampaignsApplied, _orderCheckResponse5, _orderCheckResponse5$, _orderCheckResponse5$2, _orderCheckResponse5$3, _orderCheckResponse5$4, productIds, allProducts, _unavailableProducts;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _guestUser = store_guestUser/* default.getValue */.Z.getValue();
              currentOrder = OrderDeliveryForm_objectSpread(OrderDeliveryForm_objectSpread({}, _currentOrder), {}, {
                user: {
                  phone: _guestUser === null || _guestUser === void 0 ? void 0 : _guestUser.contactPhone,
                  email: _guestUser === null || _guestUser === void 0 ? void 0 : _guestUser.email,
                  isGuestUser: Boolean(_guestUser === null || _guestUser === void 0 ? void 0 : _guestUser.email)
                }
              });
              _context4.next = 4;
              return (0,orders/* checkOrder */.Gd)(currentOrder);

            case 4:
              orderCheckResponse = _context4.sent;

              if (!orderCheckResponse.error) {
                _context4.next = 30;
                break;
              }

              _ref = ((_orderCheckResponse2 = orderCheckResponse) === null || _orderCheckResponse2 === void 0 ? void 0 : (_orderCheckResponse2$ = _orderCheckResponse2.error) === null || _orderCheckResponse2$ === void 0 ? void 0 : (_orderCheckResponse2$2 = _orderCheckResponse2$.response) === null || _orderCheckResponse2$2 === void 0 ? void 0 : (_orderCheckResponse2$3 = _orderCheckResponse2$2.data) === null || _orderCheckResponse2$3 === void 0 ? void 0 : _orderCheckResponse2$3.error) || {}, errorCode = _ref.code;
              _ref2 = ((_orderCheckResponse3 = orderCheckResponse) === null || _orderCheckResponse3 === void 0 ? void 0 : (_orderCheckResponse3$ = _orderCheckResponse3.error) === null || _orderCheckResponse3$ === void 0 ? void 0 : (_orderCheckResponse3$2 = _orderCheckResponse3$.response) === null || _orderCheckResponse3$2 === void 0 ? void 0 : (_orderCheckResponse3$3 = _orderCheckResponse3$2.data) === null || _orderCheckResponse3$3 === void 0 ? void 0 : _orderCheckResponse3$3.error) || {}, userMessage = _ref2.userMessage;

              if (!(errorCode === 'ORDVD032')) {
                _context4.next = 29;
                break;
              }

              disabledDiscountCampaignIds = (_orderCheckResponse4 = orderCheckResponse) === null || _orderCheckResponse4 === void 0 ? void 0 : (_orderCheckResponse4$ = _orderCheckResponse4.error) === null || _orderCheckResponse4$ === void 0 ? void 0 : (_orderCheckResponse4$2 = _orderCheckResponse4$.response) === null || _orderCheckResponse4$2 === void 0 ? void 0 : (_orderCheckResponse4$3 = _orderCheckResponse4$2.data) === null || _orderCheckResponse4$3 === void 0 ? void 0 : (_orderCheckResponse4$4 = _orderCheckResponse4$3.error) === null || _orderCheckResponse4$4 === void 0 ? void 0 : _orderCheckResponse4$4.params.disabledDiscountCampaignIds;
              setErrorModalMessage(userMessage);
              setModalType('genericErrorInfo');
              _context4.next = 14;
              return (0,Campaigns/* default */.Z)(true);

            case 14:
              _yield$getCampaigns2 = _context4.sent;
              campaigns = _yield$getCampaigns2.campaigns;
              error = _yield$getCampaigns2.error;

              if (!error) {
                _context4.next = 20;
                break;
              }

              handleCreateOrderError();
              return _context4.abrupt("return");

            case 20:
              service = store_deliveryMode/* default.getValue */.Z.getValue();
              collectionType = store_deliveryMode/* default.getCollectionAsNumber */.Z.getCollectionAsNumber(service);
              _context4.next = 24;
              return productsCollection/* default.updateCollection */.Z.updateCollection(collectionType);

            case 24:
              discountCampaignsApplied = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.discountCampaignsApplied.filter(function (campaignID) {
                return !disabledDiscountCampaignIds.includes(campaignID);
              });
              store_order/* Order.setDiscountCampaignsApplied */.KM.setDiscountCampaignsApplied(discountCampaignsApplied);
              campaign/* default.update */.Z.update(campaigns);
              _context4.next = 30;
              break;

            case 29:
              if (errorCode === 'OCHINT002' || errorCode === 'OCHINT013') {
                setIsProductChanges(true);
                productIds = ((_orderCheckResponse5 = orderCheckResponse) === null || _orderCheckResponse5 === void 0 ? void 0 : (_orderCheckResponse5$ = _orderCheckResponse5.error) === null || _orderCheckResponse5$ === void 0 ? void 0 : (_orderCheckResponse5$2 = _orderCheckResponse5$.response) === null || _orderCheckResponse5$2 === void 0 ? void 0 : (_orderCheckResponse5$3 = _orderCheckResponse5$2.data) === null || _orderCheckResponse5$3 === void 0 ? void 0 : (_orderCheckResponse5$4 = _orderCheckResponse5$3.error) === null || _orderCheckResponse5$4 === void 0 ? void 0 : _orderCheckResponse5$4.params) || [];
                allProducts = cart/* productsForOrder.getStorageValue */.cW.getStorageValue();
                _unavailableProducts = productIds.map(function (id) {
                  return allProducts.find(function (product) {
                    return product._id === id;
                  });
                });
                setUnavailableProducts(_unavailableProducts);
              } else if (errorCode === 'ORDVD021') {
                setErrorModalMessage(userMessage);
                setModalType('expressLimitReached');
              } else {
                setErrorModalMessage(userMessage);
                setModalType('genericErrorInfo');
              }

            case 30:
              setBagsInfo(orderCheckResponse.plasticBagsInfo);
              updateTotalPrice(((_orderCheckResponse6 = orderCheckResponse) === null || _orderCheckResponse6 === void 0 ? void 0 : (_orderCheckResponse6$ = _orderCheckResponse6.plasticBagsInfo) === null || _orderCheckResponse6$ === void 0 ? void 0 : _orderCheckResponse6$.price) || 0);

            case 32:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _checkOrderOnCheckout.apply(this, arguments);
  }

  function updateTotalPrice(bagsFee) {
    var price = cart/* totalCartPriceStore.getValue */.M$.getValue();
    var deliveryModePrice = store_deliveryMode/* default.getValue */.Z.getValue();
    setFinalCartPrice(Math.round(price));

    if (deliveryModePrice === 'express') {
      var finalPrice = price + EXPRESS_FEE + bagsFee;
      setFee(EXPRESS_FEE);
      store_order/* Order.setTotalPrice */.KM.setTotalPrice(Math.round(finalPrice));
    }

    if (deliveryModePrice === 'easy') {
      if (price < MIN_CART_PRICE) {
        var _finalPrice = price + PENALTY_FEE + bagsFee;

        setFee(PENALTY_FEE);
        store_order/* Order.setTotalPrice */.KM.setTotalPrice(Math.round(_finalPrice));
      } else {
        var _finalPrice2 = price + bagsFee;

        store_order/* Order.setTotalPrice */.KM.setTotalPrice(Math.round(_finalPrice2));
      }
    }

    if (deliveryModePrice === 'takeAway') {
      var _finalPrice3 = price + bagsFee;

      store_order/* Order.setTotalPrice */.KM.setTotalPrice(Math.round(_finalPrice3));
    }
  }

  function getShopId(serviceSelected) {
    var shop = store_shop/* Shop.getStorageValue */.k3.getStorageValue();

    if (serviceSelected === 'easy') {
      var _shop$easyShop;

      store_order/* Order.setShopId */.KM.setShopId(shop === null || shop === void 0 ? void 0 : (_shop$easyShop = shop.easyShop) === null || _shop$easyShop === void 0 ? void 0 : _shop$easyShop._id);
    } else if (serviceSelected === 'express') {
      var _shop$expressShop;

      store_order/* Order.setShopId */.KM.setShopId(shop === null || shop === void 0 ? void 0 : (_shop$expressShop = shop.expressShop) === null || _shop$expressShop === void 0 ? void 0 : _shop$expressShop._id);
    } else {
      var _shop$takeAwayShop;

      store_order/* Order.setShopId */.KM.setShopId(shop === null || shop === void 0 ? void 0 : (_shop$takeAwayShop = shop.takeAwayShop) === null || _shop$takeAwayShop === void 0 ? void 0 : _shop$takeAwayShop._id);
    }
  }

  function onSubmit(data) {
    var hasTimeslotError = onClickSubmit();

    if (!hasTimeslotError) {
      if (data.companyAddress) {
        var invoiceData = {
          companyAddress: data.companyAddress,
          companyName: data.companyName,
          companyPhone: data.companyPhone,
          profession: data.profession,
          AFM: data.AFM,
          DOY: data.DOY
        };
        store_order/* Order.setInvoiceInfo */.KM.setInvoiceInfo(invoiceData);
      } else {
        store_order/* Order.deleteProperty */.KM.deleteProperty(['invoice']);
      }

      onSubmitOrder();
    }
  }

  (0,react.useEffect)(function () {
    cart/* default.setIsEditable */.ZP.setIsEditable(false);
    cart/* default.setIsVisible */.ZP.setIsVisible(false);
    var deliveryMode$ = store_deliveryMode/* default.subscribe */.Z.subscribe(function (service) {
      setDeliveryMode(service);
      getShopId(service);
      var orderShippingType = service === 'takeAway' ? 'takeAway' : 'delivery';
      var order = store_order/* Order.getValue */.KM.getValue();
      store_order/* Order.update */.KM.update(OrderDeliveryForm_objectSpread(OrderDeliveryForm_objectSpread({}, order), {}, {
        selectedService: service,
        orderShippingType: orderShippingType,
        redeemPoints: false,
        couponCode: undefined
      }));
    });
    var user$ = (0,combineLatest/* combineLatest */.aj)([store_user/* default._lazyInit */.Z._lazyInit(), store_guestUser/* default._lazyInit */.Z._lazyInit()]).subscribe(function (res) {
      var user = res[0];
      var guest = res[1];

      if (!(user !== null && user !== void 0 && user._id) && !(guest !== null && guest !== void 0 && guest.email)) {
        router.replace('/');
      }
    });
    var guestUser$ = store_guestUser/* default.subscribe */.Z.subscribe(function (_guestUser) {
      setGuestUser(_guestUser);
    });
    var price$ = cart/* cartPrice.subject.pipe */.O0.subject.pipe((0,filter/* filter */.h)(function (v) {
      return v;
    }), (0,distinctUntilChanged/* distinctUntilChanged */.x)()).subscribe(function (price) {
      var currentService = store_deliveryMode/* default.getValue */.Z.getValue();

      if (currentService === 'easy' && price < MIN_CART_PRICE) {
        store_order/* Order.setPenalty */.KM.setPenalty(PENALTY_FEE, MIN_CART_PRICE);
        return;
      }

      if (currentService === 'express') {
        store_order/* Order.setPenalty */.KM.setPenalty(EXPRESS_FEE, undefined);
        return;
      }

      if (currentService === 'takeAway') {
        store_order/* Order.setPenalty */.KM.setPenalty(0, MIN_CART_TAKEAWAY);
        return;
      }

      store_order/* Order.setPenalty */.KM.setPenalty(undefined, undefined);
    });

    var _modifyProduct = modifyProduct(),
        _modifyProduct2 = (0,slicedToArray/* default */.Z)(_modifyProduct, 2),
        _modifyProduct2$ = _modifyProduct2[0],
        orderProducts = _modifyProduct2$ === void 0 ? [] : _modifyProduct2$,
        _modifyProduct2$2 = _modifyProduct2[1],
        orderOffers = _modifyProduct2$2 === void 0 ? [] : _modifyProduct2$2;

    var products = orderProducts.length ? orderProducts : undefined;
    store_order/* Order.setProducts */.KM.setProducts(products);
    var offers = orderOffers.length ? orderOffers : undefined;
    store_order/* Order.setOffers */.KM.setOffers(offers);
    var shops$ = store_shop/* TakeAwayShops.subscribe */.hP.subscribe(setTakeAwayShops);
    var order$ = store_order/* Order.subject.pipe */.KM.subject.pipe((0,distinctUntilChanged/* distinctUntilChanged */.x)(function (prev, curr) {
      return (prev === null || prev === void 0 ? void 0 : prev.wantPlasticBags) === (curr === null || curr === void 0 ? void 0 : curr.wantPlasticBags);
    })).subscribe(function (_order) {
      var _orderCheckResponse, _orderCheckResponse$p;

      if (!orderCheckResponse || _order === undefined) return;

      if (!(_order !== null && _order !== void 0 && _order.wantPlasticBags)) {
        updateTotalPrice(0);
        setBagsInfo({
          amount: 0,
          price: 0
        });
        return;
      }

      updateTotalPrice(((_orderCheckResponse = orderCheckResponse) === null || _orderCheckResponse === void 0 ? void 0 : (_orderCheckResponse$p = _orderCheckResponse.plasticBagsInfo) === null || _orderCheckResponse$p === void 0 ? void 0 : _orderCheckResponse$p.price) || 0);
      setBagsInfo(orderCheckResponse.plasticBagsInfo);
    });
    var order = store_order/* Order.getValue */.KM.getValue();

    var _orderWithBags = OrderDeliveryForm_objectSpread(OrderDeliveryForm_objectSpread({}, order), {}, {
      totalPrice: undefined
    });

    checkOrderOnCheckout(_orderWithBags);

    function checkForOfferChange() {
      return _checkForOfferChange.apply(this, arguments);
    }

    function _checkForOfferChange() {
      _checkForOfferChange = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var productsInCart, offersWithPriceChange;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                productsInCart = cart/* productsForOrder.getStorageValue */.cW.getStorageValue();
                _context.next = 3;
                return (0,getOffers/* getOffersWithPriceChange */.f5)(productsInCart);

              case 3:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 6;
                  break;
                }

                _context.t0 = [];

              case 6:
                offersWithPriceChange = _context.t0;

                if (offersWithPriceChange.length) {
                  setPriceChangeProducts(offersWithPriceChange);
                  setIsProductChanges(true);
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _checkForOfferChange.apply(this, arguments);
    }

    checkForOfferChange();
    var isEligibleToRate$ = store_user/* default.isEligibleToRate$ */.Z.isEligibleToRate$().subscribe(setIsEligibleToRate);
    return function () {
      console.debug('OrderDeliveryForm', 'useEffect', 'unmount');
      user$.unsubscribe();
      deliveryMode$.unsubscribe();
      isEligibleToRate$.unsubscribe();
      shops$.unsubscribe();
      order$.unsubscribe();
      price$.unsubscribe();
      guestUser$.unsubscribe();
    };
  }, []);

  var unsupportedPostalCodeError = function () {
    if (!postalCodeUnsupported) return '';
    if (deliveryMode === 'takeAway') return TAKEAWAY_UNSUPPORTED_POSTAL_CODE_ERROR;
    return DELIVERY_UNSUPPORTED_POSTAL_CODE_ERROR;
  }();

  function getInfoModalFunction() {
    switch (modalType) {
      case 'expressLimitReached':
        return function () {
          setModalType('');
          router.back();
        };

      case 'noTimeslot':
        return function () {
          setModalType('');
          window.scrollTo({
            top: 500,
            behavior: 'smooth'
          });
        };

      default:
        return function () {
          return setModalType('');
        };
    }
  }

  (0,react.useEffect)(function () {
    var errorsArray = Object.keys(errors);

    if (errorsArray[0]) {
      var inputWithError = document.querySelector("[name=\"".concat(errorsArray[0], "\"]"));
      inputWithError.scrollIntoView({
        behavior: 'auto',
        block: 'center'
      });
    }
  }, [errors]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (OrderDeliveryForm_module_default()).checkoutForm,
      children: [deliveryMode === 'takeAway' && /*#__PURE__*/(0,jsx_runtime.jsx)(ShopPicker, {
        setOpenTakeAwayModal: setOpenTakeAwayModal
      }), (deliveryMode !== 'takeAway' || (guestUser === null || guestUser === void 0 ? void 0 : guestUser.email)) && /*#__PURE__*/(0,jsx_runtime.jsx)(AddressPicker, {
        className: (OrderDeliveryForm_module_default()).addressPickerContainer,
        guestTakeAway: deliveryMode === 'takeAway' && (guestUser === null || guestUser === void 0 ? void 0 : guestUser.email)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TimeSlotsToDeliver, {
        setPostalCodeUnsupported: setPostalCodeUnsupported
      }), unsupportedPostalCodeError ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (OrderDeliveryForm_module_default()).errorMsg,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: unsupportedPostalCodeError
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        noValidate: true,
        className: (OrderDeliveryForm_module_default()).form,
        name: "orderDeliveryForm",
        onSubmit: handleSubmit(onSubmit),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OrderDeliveryForm_OrderPreferences, {
          control: control,
          bagsInfo: bagsInfo,
          couponNo: couponNo
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (OrderDeliveryForm_module_default()).btnContainer,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* PrimaryButton */.KM, {
            type: "submit",
            "data-cy": "submit-order-CTA",
            children: "\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2"
          })
        })]
      })]
    }), deliveryMode === 'takeAway' && /*#__PURE__*/(0,jsx_runtime.jsx)(TakeAwayModal/* default */.Z, {
      isOpen: isTakeAwayModalOpen,
      setIsOpen: setOpenTakeAwayModal,
      shops: takeAwayShops,
      onShopClicked: onClickSelectStore
    }), isModalSuccessOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderAlertSuccess, {
      isModalOpen: isModalSuccessOpen,
      onClickOk: onClickOkReceipt,
      isForGuestUser: !!(guestUser !== null && guestUser !== void 0 && guestUser.email)
    }), isConfirmationModalOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(ConfirmationModal["default"], {
      mainText: errorModalMessage,
      isOpen: isConfirmationModalOpen,
      modalLabel: "Confirmation modal",
      backBtnText: "\u0391\u03BA\u03C5\u03C1\u03BF",
      continueBtnText: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1",
      onClickContinue: onAcceptCharges,
      onClickBack: function onClickBack() {
        return setIsConfirmationModalOpen(false);
      },
      modalClose: function modalClose() {
        return setIsConfirmationModalOpen(false);
      }
    }), modalType && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoModal/* default */.Z, {
      mainText: errorModalMessage,
      onClickContinue: function onClickContinue() {
        return getInfoModalFunction()();
      },
      continueBtnText: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1",
      modalLabel: "Info modal"
    }), isProductChanges && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductsChangesModal, {
      isModalOpen: isProductChanges,
      setIsModalOpen: setIsProductChanges,
      updatedProducts: priceChangeProducts,
      unavailableProducts: unavailableProducts,
      modifyProduct: modifyProduct
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AppRatingModal/* default */.Z, {
      isModalOpen: isAppRatingModalOpen,
      onSuccessfulSubmit: onSuccessfulRatingSubmit,
      onClose: function onClose() {
        setIsAppRatingModalOpen(false);
        router.replace('/');
      }
    })]
  });
}
// EXTERNAL MODULE: ./src/pages/order-delivery.module.scss
var order_delivery_module = __webpack_require__(4661);
var order_delivery_module_default = /*#__PURE__*/__webpack_require__.n(order_delivery_module);
;// CONCATENATED MODULE: ./src/pages/order-delivery/index.jsx









var __N_SSG = true;
function OrderDelivery(_ref) {
  var footerLinks = _ref.footerLinks,
      navigation = _ref.navigation;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (order_delivery_module_default()).pageContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CustomHead/* default */.Z, {
      title: "\u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03A0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).headerContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
        navigation: navigation,
        isDisabled: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
        navigation: navigation
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (order_delivery_module_default()).layout,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OrderDeliveryForm, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (order_delivery_module_default()).footerContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
        footerLinks: footerLinks
      })
    })]
  });
}

/***/ }),

/***/ 81786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ TakeAwayTimeslotsFetched; },
/* harmony export */   "Ku": function() { return /* binding */ ExpressTimeslotsStore; },
/* harmony export */   "dX": function() { return /* binding */ TakeAwayTimeslotsStore; },
/* harmony export */   "sz": function() { return /* binding */ ExpressTimeslotsFetched; }
/* harmony export */ });
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20090);

var subjectTakeAwayTimeslotsFetched = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X(false);
var subjectExpressTimeslotsFetched = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X(false);
var TakeAwayTimeslotsFetched = {
  update: function update(fetched) {
    subjectTakeAwayTimeslotsFetched.next(fetched);
  }
};
var TakeAwayTimeslotsStore = {
  subject: new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X([]),
  update: function update(timeslots) {
    TakeAwayTimeslotsStore.subject.next(timeslots);
    TakeAwayTimeslotsFetched.update(true);
  },
  subscribe: function subscribe(setState) {
    return TakeAwayTimeslotsStore.subject.subscribe(setState);
  },
  getValue: function getValue() {
    return TakeAwayTimeslotsStore.subject.value;
  },
  isFetched: function isFetched() {
    return subjectTakeAwayTimeslotsFetched.value;
  }
};
var ExpressTimeslotsFetched = {
  update: function update(fetched) {
    subjectExpressTimeslotsFetched.next(fetched);
  }
};
var ExpressTimeslotsStore = {
  subject: new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X([]),
  update: function update(timeslots) {
    ExpressTimeslotsStore.subject.next(timeslots);
    ExpressTimeslotsFetched.update(true);
  },
  subscribe: function subscribe(setState) {
    return ExpressTimeslotsStore.subject.subscribe(setState);
  },
  getValue: function getValue() {
    return ExpressTimeslotsStore.subject.value;
  },
  isFetched: function isFetched() {
    return subjectExpressTimeslotsFetched.value;
  }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  TakeAwayTimeslotsStore: TakeAwayTimeslotsStore,
  ExpressTimeslotsStore: ExpressTimeslotsStore,
  TakeAwayTimeslotsFetched: TakeAwayTimeslotsFetched,
  ExpressTimeslotsFetched: ExpressTimeslotsFetched
});

/***/ }),

/***/ 81287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f5": function() { return /* binding */ getOffersWithPriceChange; },
  "Oc": function() { return /* binding */ getOrFetchOffers; }
});

// UNUSED EXPORTS: updateOffers

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(39666);
// EXTERNAL MODULE: ./src/api/config/index.js + 2 modules
var config = __webpack_require__(65599);
;// CONCATENATED MODULE: ./src/api/Offers.js




var GET_OFFERS_ENDPOINT = '/v2/offers/eligible';
function getOffers() {
  return _getOffers.apply(this, arguments);
}

function _getOffers() {
  _getOffers = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _response$data, _response$data$payloa, response, offers;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return config/* wave.get */.t.get(GET_OFFERS_ENDPOINT);

          case 3:
            response = _context.sent;
            offers = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$payloa = _response$data.payload) === null || _response$data$payloa === void 0 ? void 0 : _response$data$payloa.offers;

            if (offers) {
              _context.next = 8;
              break;
            }

            (0,esm/* captureMessage */.uT)("Fetched Unproccessable entity from ".concat(GET_OFFERS_ENDPOINT));
            return _context.abrupt("return", []);

          case 8:
            if (!offers.length) (0,esm/* captureMessage */.uT)("Fetched empty array from ".concat(GET_OFFERS_ENDPOINT));
            return _context.abrupt("return", offers);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            (0,esm/* captureException */.Tb)(_context.t0);
            console.error(_context.t0);
            return _context.abrupt("return", []);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));
  return _getOffers.apply(this, arguments);
}
// EXTERNAL MODULE: ./src/store/offers.js
var store_offers = __webpack_require__(4251);
;// CONCATENATED MODULE: ./src/utils/getOffers.js





function getOrFetchOffers() {
  if (store_offers/* OffersStore.isFetched */.mf.isFetched()) {
    return store_offers/* OffersStore.getValue */.mf.getValue();
  }

  return updateOffers();
}

function updateOffers() {
  return _updateOffers.apply(this, arguments);
}

function _updateOffers() {
  _updateOffers = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var offers;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getOffers();

          case 2:
            offers = _context.sent;
            store_offers/* OffersStore.update */.mf.update(offers);
            return _context.abrupt("return", offers);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _updateOffers.apply(this, arguments);
}

function getOffersWithPriceChange(_x) {
  return _getOffersWithPriceChange.apply(this, arguments);
}

function _getOffersWithPriceChange() {
  _getOffersWithPriceChange = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(productsForOrder) {
    var offersInCart, allOffers, offersWithChangedPrice;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            offersInCart = productsForOrder === null || productsForOrder === void 0 ? void 0 : productsForOrder.filter(function (p) {
              return p.isSpecialOffer;
            });

            if (offersInCart !== null && offersInCart !== void 0 && offersInCart.length) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", []);

          case 3:
            _context2.next = 5;
            return updateOffers();

          case 5:
            allOffers = _context2.sent;
            offersWithChangedPrice = offersInCart.map(function (offerFromCart) {
              return allOffers.find(function (offer) {
                return offer._id === offerFromCart._id && offer.price !== offerFromCart.price;
              });
            });
            return _context2.abrupt("return", offersWithChangedPrice.filter(function (o) {
              return o;
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getOffersWithPriceChange.apply(this, arguments);
}



/***/ }),

/***/ 65168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ theme; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21265);
/* harmony import */ var _styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65447);
/* harmony import */ var _styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
  typography: {
    fontFamily: _styles_layout_module_scss__WEBPACK_IMPORTED_MODULE_1__.brandFontFamily
  }
});

/***/ }),

/***/ 74926:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-delivery",
      function () {
        return __webpack_require__(15064);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33787:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addressContainer":"AddressSelection_addressContainer___nVHw","addressListContainer":"AddressSelection_addressListContainer__NlBFG","addresList":"AddressSelection_addresList__D4SWi","addressInfo":"AddressSelection_addressInfo__5ImyX","addressItem":"AddressSelection_addressItem__Ls1Qi","addressType":"AddressSelection_addressType__HecUY","addressTypeSelected":"AddressSelection_addressTypeSelected__rzyMS","addressInfoContainer":"AddressSelection_addressInfoContainer__JUaS2","addressIcon":"AddressSelection_addressIcon__kXYie","addressIconSelected":"AddressSelection_addressIconSelected__YZvQ2","addressDetails":"AddressSelection_addressDetails__idBiK","addressDetailsSelected":"AddressSelection_addressDetailsSelected__7FTQx","addAddressBtn":"AddressSelection_addAddressBtn__scLHp","buttonContainer":"AddressSelection_buttonContainer__Inn8m","buttonText":"AddressSelection_buttonText__a6Yfy","addressRadioContainer":"AddressSelection_addressRadioContainer__6p6IN","selectedAddress":"AddressSelection_selectedAddress__cbYzx","mapContainer":"AddressSelection_mapContainer__NsJyQ"};

/***/ }),

/***/ 18780:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressSelectionModal_container__Q9AS_","header":"AddressSelectionModal_header__ASlTz","modalHeader":"AddressSelectionModal_modalHeader__2BcoS","close":"AddressSelectionModal_close__NUzBr","closeModal":"AddressSelectionModal_closeModal__ITver","modalHeaderMobile":"AddressSelectionModal_modalHeaderMobile__QX_hE"};

/***/ }),

/***/ 19563:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"AddressViewModal_modalHeader__fbOFm"};

/***/ }),

/***/ 74007:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkboxGeneralContainer":"GDPRCheckbox_checkboxGeneralContainer__qLYn0","checkbox":"GDPRCheckbox_checkbox__OXEhU","checkboxText":"GDPRCheckbox_checkboxText__cz6_y","link":"GDPRCheckbox_link__QhsZd","checkboxContainer":"GDPRCheckbox_checkboxContainer__nU1M5"};

/***/ }),

/***/ 61429:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"GenericModalV2_modalContainer__aCXv8","modalContent":"GenericModalV2_modalContent__Mpl98","text":"GenericModalV2_text__vXm9C","footer":"GenericModalV2_footer__YXTWC","btn":"GenericModalV2_btn__rhKmF"};

/***/ }),

/***/ 4401:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"GuestDetailsModal_overlay__Gd5LB","closeSymbol":"GuestDetailsModal_closeSymbol__tb3mU","container":"GuestDetailsModal_container__W12MJ","content":"GuestDetailsModal_content__QTnai","body":"GuestDetailsModal_body__neMu2","header":"GuestDetailsModal_header__EDNVA","modalHeader":"GuestDetailsModal_modalHeader__6oQqJ","close":"GuestDetailsModal_close__AC04Q"};

/***/ }),

/***/ 48902:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"GuestView_sectionHeader__bW7cq","inputContainer":"GuestView_inputContainer__MeaTu","box":"GuestView_box__GdIbF","waringIcon":"GuestView_waringIcon__iCPJ2","errorSmallText":"GuestView_errorSmallText__AmV0O","loginText":"GuestView_loginText__7hWAL","loginLink":"GuestView_loginLink__7_pVF"};

/***/ }),

/***/ 17569:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"OrderAlertModal_modalContainer__tyEcV","text":"OrderAlertModal_text__V_YPc"};

/***/ }),

/***/ 38851:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"OrderAlertSuccess_modalContainer__5bin_","logo":"OrderAlertSuccess_logo__xGEDc","textContainer":"OrderAlertSuccess_textContainer__3Fvag","checkMark":"OrderAlertSuccess_checkMark__bbpM3","text":"OrderAlertSuccess_text__MIlZ4","detailsText":"OrderAlertSuccess_detailsText__Ut6t_","orderInfoContainer":"OrderAlertSuccess_orderInfoContainer__zJ2ZE","orderText":"OrderAlertSuccess_orderText__XqFr0","orderInfo":"OrderAlertSuccess_orderInfo__uV_R0","btnContainer":"OrderAlertSuccess_btnContainer__2y_8r","acceptBtn":"OrderAlertSuccess_acceptBtn__K6i2p"};

/***/ }),

/***/ 25614:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"AddressPicker_section__sZJ5C","addressContainer":"AddressPicker_addressContainer__2Yqo0","addressTitle":"AddressPicker_addressTitle__jXkkr","instructions":"AddressPicker_instructions__osqf_","addresList":"AddressPicker_addresList__DH5zC","addressInfo":"AddressPicker_addressInfo__f1BPf","btnContainer":"AddressPicker_btnContainer__CdlDJ","buttonText":"AddressPicker_buttonText__HN_XX","addressItem":"AddressPicker_addressItem__5xpX0","addressType":"AddressPicker_addressType__wcer_","containerAddress":"AddressPicker_containerAddress__b5lyo","addressDetails":"AddressPicker_addressDetails__k1xY8","storeInfo":"AddressPicker_storeInfo__ZJfHh","addressStore":"AddressPicker_addressStore__ajMuj","addressIcon":"AddressPicker_addressIcon__cb3TZ","addAddressBtn":"AddressPicker_addAddressBtn__xgqUa","mapContainer":"AddressPicker_mapContainer__qj5PD","selectedAddress":"AddressPicker_selectedAddress__4dgzl"};

/***/ }),

/***/ 73019:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkoutForm":"OrderDeliveryForm_checkoutForm__QI9Ux","errorMsg":"OrderDeliveryForm_errorMsg__zgxh1","btnContainer":"OrderDeliveryForm_btnContainer__u8CKk"};

/***/ }),

/***/ 13611:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boxShadow":"0 .125rem .125rem 0 rgba(0,0,0,.2)","brandColor":"#2f4486","brandColorMuted":"#828fb6","bgColor":"#f9f9f9","bodyDefault":"#333","section":"OrderPreferences_section__2a2J8","instructions":"OrderPreferences_instructions__MDu85","preferencesTitle":"OrderPreferences_preferencesTitle__oQUWU","paymentMethodLabel":"OrderPreferences_paymentMethodLabel__fgOXY","labelAsterisk":"OrderPreferences_labelAsterisk__Hyoe_","errorMessage":"OrderPreferences_errorMessage__KztbZ","paymentMethodSelect":"OrderPreferences_paymentMethodSelect__oso4t","paymentMethodImg":"OrderPreferences_paymentMethodImg__iVG_u","radioContainer":"OrderPreferences_radioContainer__ydvAA","radioLabel":"OrderPreferences_radioLabel__6FMcv","checkBoxContainer":"OrderPreferences_checkBoxContainer__G9H_q","checkBoxLabel":"OrderPreferences_checkBoxLabel__PJzJt","textAreaLabel":"OrderPreferences_textAreaLabel__Ktkws","textArea":"OrderPreferences_textArea__PdDmj","wordCountText":"OrderPreferences_wordCountText__n_8AK","labelText":"OrderPreferences_labelText__3Erwa","details":"OrderPreferences_details__qQcNY","btnContainer":"OrderPreferences_btnContainer__3VUH1","submitBtn":"OrderPreferences_submitBtn__Wzxof","hideOnUnselected":"OrderPreferences_hideOnUnselected__hGqkw","appearOnSelected":"OrderPreferences_appearOnSelected__Gz9aD","invoiceInputContainer":"OrderPreferences_invoiceInputContainer__q80vd","couponInputContainer":"OrderPreferences_couponInputContainer__eG4Vd","extraInfoLabel":"OrderPreferences_extraInfoLabel__A8bpJ","extraInfoInput":"OrderPreferences_extraInfoInput__n7OHx","hidden":"OrderPreferences_hidden__ILwD3","paymentMethodModalContainer":"OrderPreferences_paymentMethodModalContainer__2FLIi","paymentMethodButton":"OrderPreferences_paymentMethodButton__wcmko","imgDropdown":"OrderPreferences_imgDropdown__Etsrz","paymentMethodSelectContainer":"OrderPreferences_paymentMethodSelectContainer__38De3","radioOption":"OrderPreferences_radioOption__247Qq","opacity":"OrderPreferences_opacity__D4Vus","infoIcon":"OrderPreferences_infoIcon__ydT9t","couponArrow":"OrderPreferences_couponArrow__2P1ln","resetButton":"OrderPreferences_resetButton__hVZJw","couponSuccess":"OrderPreferences_couponSuccess__nM4f7"};

/***/ }),

/***/ 11470:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slotButton":"TimeSlotsMobile_slotButton__5l_Ld","arrowIcon":"TimeSlotsMobile_arrowIcon__FKxm8"};

/***/ }),

/***/ 45312:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"TimeSlotsToDeliver_section__p6a3B","timeSlotsTitle":"TimeSlotsToDeliver_timeSlotsTitle__Y_u14","instructions":"TimeSlotsToDeliver_instructions__IcBCP","selectionDayContainer":"TimeSlotsToDeliver_selectionDayContainer__lAR9T","selectionDay":"TimeSlotsToDeliver_selectionDay___WMIs","timeslotsWidth":"TimeSlotsToDeliver_timeslotsWidth___INKN","selectionDayHeader":"TimeSlotsToDeliver_selectionDayHeader__eA_31","expressLabelContainer":"TimeSlotsToDeliver_expressLabelContainer__A_b_7","timeSlotInput":"TimeSlotsToDeliver_timeSlotInput__Iak1V","timeSlotLabel":"TimeSlotsToDeliver_timeSlotLabel__AThPE","selectedTimeslot":"TimeSlotsToDeliver_selectedTimeslot__c2Bvz","disabledTimeslot":"TimeSlotsToDeliver_disabledTimeslot__2vMXd","selectContainer":"TimeSlotsToDeliver_selectContainer__FrQVi","errorMsg":"TimeSlotsToDeliver_errorMsg__C8JkT","layout":"TimeSlotsToDeliver_layout__ygK5v"};

/***/ }),

/***/ 12185:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"PaymentMethodModal_modalHeader__EO0bL","option":"PaymentMethodModal_option__9lV4n","container":"PaymentMethodModal_container__KC8zG","selectedOption":"PaymentMethodModal_selectedOption__D8S_O","paymentMethodImg":"PaymentMethodModal_paymentMethodImg__J9d8g"};

/***/ }),

/***/ 1438:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"ProductChangesModal_content__2naDZ","header":"ProductChangesModal_header__lJsHb","headerTitle":"ProductChangesModal_headerTitle__O_jGD","closeBtn":"ProductChangesModal_closeBtn__xSsci","closeModal":"ProductChangesModal_closeModal__8iR2M","body":"ProductChangesModal_body__icMx9","message":"ProductChangesModal_message__yWJyH","sectionTitle":"ProductChangesModal_sectionTitle__VbzdJ","footer":"ProductChangesModal_footer__WCLW8","rightButton":"ProductChangesModal_rightButton__i25gr","productsContainer":"ProductChangesModal_productsContainer__IcEJ5","productTile":"ProductChangesModal_productTile__SsBZU","productTileImg":"ProductChangesModal_productTileImg__NiU_9","info":"ProductChangesModal_info__aHKQf","extraInfo":"ProductChangesModal_extraInfo__ueP6c","unavailable":"ProductChangesModal_unavailable__8NY_4"};

/***/ }),

/***/ 56117:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"TimeSlotModal_modalHeader__Ewu0q","option":"TimeSlotModal_option__LP_Xp","selectedOption":"TimeSlotModal_selectedOption__5iFBT","container":"TimeSlotModal_container__LOC0V"};

/***/ }),

/***/ 4661:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"layout":"order-delivery_layout__AB1_U"};

/***/ }),

/***/ 65447:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"brandFontFamily":"\"Roboto\",Helvetica,Arial,sans-serif","container":"layout_container__8mgcn","section":"layout_section__q1Enk","row":"layout_row___Mosi"};

/***/ }),

/***/ 28833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__J9svF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,5937,9866,1228,4617,5445,3609,260,2013,3253,3996,4843,9979,5642,7536,3988,9174,5397,2636,9950,2998,6669,4099,8566,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(74926); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);